var LEGACY_API_BASE_URL = 'https://legacy-api.wego.app/';
var GATEWAY_BASE_URL = 'https://api.wego.app/';

var SSO_BASE_URL = GATEWAY_BASE_URL;
var API_SERVER_URL = GATEWAY_BASE_URL + 'api/backoffice/v1/gateway/';

var CONFIRMED_URL = 'https://wego.app/confirmed/index.html';

export const WeGoConfig = {
  GATEWAY_BASE_URL : GATEWAY_BASE_URL,
  LEGACY_API_BASE_URL : LEGACY_API_BASE_URL ,
  TELTONIKA_CONFIG_BASE_URL: GATEWAY_BASE_URL + 'teltonika',
  INVERS_CONFIG_BASE_URL:  "https://fleetcontrol.invers.com/inspect/C-",
  APP_VERSION: "v3.3.1",
  API_SERVER_URL: API_SERVER_URL,
  GRID_MAX_PAGE_SIZE: 5,
  GRID_MAX_DATA_SIZE: 10,
  GRID_PAGGING: [10, 20, 50, 100],
  NOTIFICATION_REFRESH_INTERVAL_SEC: 30,
  ONLINE_PAYMENT_SERVICE_REFRESH_INTERVAL_SEC: 30,
  API_CLIENT_ID: 'wegoBackoffice',
   API_GOOGLE_MAP_URL: 'https://maps.googleapis.com/maps/api/geocode/json?sensor=false&key=AIzaSyD4J2ULaq2kZFRxfULmLqyWC5HEtns2JXo&latlng=',

  API_GET_LOGIN_ACCESS_TOKEN: GATEWAY_BASE_URL + 'token',
  API_GET_ROLE_BY_PERSON:
    API_SERVER_URL + 'api/Backoffice/GetRolesByPersonHashID',
  API_GET_USER_SETTING_BY_PERSON:
    API_SERVER_URL + 'api/Backoffice/GetUserSettingByPersonHashID',
  CONFIRMED_URL : CONFIRMED_URL,
  FLATPICKR_DATE_TIME_FORMAT: 'd-m-Y H:i',
  FLATPICKR_TIME_FORMAT: 'H:i',
  FLATPICKR_DATE_FORMAT: 'd-m-Y',
  WEGOADMIN_USER: 'wegoadmin',
  HERE_MAP_AUTOCOMPLETION_URL: 'https://autocomplete.geocoder.api.here.com/6.2/suggest.json',
  HERE_MAP_LOCATION_URL: 'https://geocoder.api.here.com/6.2/geocode.json',
  HERE_MAP_REVERSE_GEOCODE_URL: 'https://revgeocode.search.hereapi.com/v1/revgeocode',
  HERE_MAP_API_KEY: 'vhwGi_VH2seP-qvlCC9ricG-7gu9hA-1IFHPVZxLBy8',
  HERE_MAP_APP_ID: 'cRmJl4dUw8q4uoLZnLyq',
  HERE_MAP_APP_CODE: 'gOrxJBGaXLBnzZPF7Ba67A',
  HERE_MAP_LOC_RADIUS: '250',

  CURRENCY_ABBREVIATION: [
    'AED',
    'AFN',
    'ALL',
    'AMD',
    'ANG',
    'AOA',
    'AQD',
    'ARS',
    'AUD',
    'AZN',
    'BAM',
    'BBD',
    'BGN',
    'BHD',
    'BIF',
    'BMD',
    'BND',
    'BOB',
    'BRL',
    'BSD',
    'BWP',
    'BYR',
    'BZD',
    'CAD',
    'CDF',
    'CHF',
    'CLP',
    'CNY',
    'COP',
    'CRC',
    'CUP',
    'CVE',
    'CYP',
    'CZK',
    'DJF',
    'DKK',
    'DOP',
    'DZD',
    'ECS',
    'EEK',
    'EGP',
    'ETB',
    'EUR',
    'FJD',
    'FKP',
    'GBP',
    'GEL',
    'GGP',
    'GHS',
    'GIP',
    'GMD',
    'GNF',
    'GTQ',
    'GYD',
    'HKD',
    'HNL',
    'HRK',
    'HTG',
    'HUF',
    'IDR',
    'ILS',
    'INR',
    'IQD',
    'IRR',
    'ISK',
    'JMD',
    'JOD',
    'JPY',
    'KES',
    'KGS',
    'KHR',
    'KMF',
    'KPW',
    'KRW',
    'KWD',
    'KYD',
    'KZT',
    'LAK',
    'LBP',
    'LKR',
    'LRD',
    'LSL',
    'LTL',
    'LVL',
    'LYD',
    'MAD',
    'MDL',
    'MGA',
    'MKD',
    'MMK',
    'MNT',
    'MOP',
    'MRO',
    'MTL',
    'MUR',
    'MVR',
    'MWK',
    'MXN',
    'MYR',
    'MZN',
    'NAD',
    'NGN',
    'NIO',
    'NOK',
    'NPR',
    'NZD',
    'OMR',
    'PAB',
    'PEN',
    'PGK',
    'PHP',
    'PKR',
    'PLN',
    'PYG',
    'QAR',
    'RON',
    'RSD',
    'RUB',
    'RWF',
    'SAR',
    'SBD',
    'SCR',
    'SDG',
    'SEK',
    'SGD',
    'SKK',
    'SLL',
    'SOS',
    'SRD',
    'STD',
    'SVC',
    'SYP',
    'SZL',
    'THB',
    'TJS',
    'TMT',
    'TND',
    'TOP',
    'TRY',
    'TTD',
    'TWD',
    'TZS',
    'UAH',
    'UGX',
    'USD',
    'UYU',
    'UZS',
    'VEF',
    'VND',
    'VUV',
    'XAF',
    'XCD',
    'XOF',
    'XPF',
    'YER',
    'ZAR',
    'ZMK',
    'ZWD'
  ],

  PREFERRED_LANGUAGE: ['NL', 'DE', 'EN', 'FR', 'PT'],
  TERMS_CONDITION_PRIVACYTYPE: ['T&C', 'Privacy'],

  DEFAULT_GEOLOCATION: { Lat: 52.3702, Long: 4.89517 },

  API_GET_IS_AUTHORIZE_FOR: API_SERVER_URL + 'api/HasRights/IsAuthorizeFor',
  API_GET_IS_AUTHORIZE_URL: API_SERVER_URL + 'api/HasRights/IsAuthorizeURL',
  API_GET_IS_AUTHORIZE_FOR_DUAL_PERMISSION:
    API_SERVER_URL + 'api/HasRights/IsAuthorizeForDualPermission',
  API_GET_BACKOFFICE_MENU: API_SERVER_URL + 'api/HasRights/GetBackOfficeMenu',
  API_GET_TELEPHONE_COUNTRY:
    API_SERVER_URL + 'api/Backoffice/GetTelephoneCountry',

    API_GET_PERSON_COUNTRY_LIST:
    API_SERVER_URL + 'api/Backoffice/GetPersonCountryList',

  //Branding
  API_POST_UPDATE_BRANDING: API_SERVER_URL + 'api/Branding/UpdateBranding',
  API_GET_BRANDING: API_SERVER_URL + 'api/Branding/GetBranding',

  //PersonMaster
  API_GET_PERSON_LIST: API_SERVER_URL + 'api/PersonMaster/GetAllPersonList',
  API_GET_ADMIN_LIST:
    API_SERVER_URL + 'api/PersonMaster/GetAllAdminForBookingRequest',
  API_GET_PERSON_BY_HASH: API_SERVER_URL + 'api/PersonMaster/GetPersonByHashID',
  API_POST_PERSON_DETAIL:
    API_SERVER_URL + 'api/PersonMaster/UpdatePersonMaster',
  API_DELETE_PERSON: API_SERVER_URL + 'api/PersonMaster/DeletePersonMaster',
  API_RESET_PASSWORD_PERSON:
    API_SERVER_URL + 'api/PersonMaster/ResetPersonPassword',
  API_EXPORT_PERSON_LIST: API_SERVER_URL + 'api/PersonMaster/ExportPerson',
  API_POST_UPDATE_PERSON_LANGUAGE:
    API_SERVER_URL + 'api/PersonMaster/UpdateUserLanguagePreference',
  API_RESEND_ACTIVATION_MAIL_URL:
    API_SERVER_URL + 'api/PersonMaster/ReSendActivationMail',
  API_GET_PROFILE_DETAIL: API_SERVER_URL + 'api/PersonMaster/GetProfileDetail',
  API_GET_CREDITCARD_DETAILS:
    API_SERVER_URL + 'api/PersonMaster/GetCreditCardDetails',
  API_GET_PERSON_LIST_FOR_COST_EXPENSE_LIST:
    API_SERVER_URL + 'api/PersonMaster/GetPersonListForCostExpense',
  API_UPDATE_PERSON_REMOVAL_DATE_URL:
    API_SERVER_URL + 'api/PersonMaster/UpdatePersonRemovalDate',

  API_ACTIVATE_PERSON_URL:
    API_SERVER_URL + 'api/PersonMaster/ActivatePerson',

  API_RESET_TWOFA_COOKIE_PERSON:
    API_SERVER_URL + 'api/PersonMaster/ResetTwoFaCookiesForPerson',

  API_RESET_TWOFA_KEY_PERSON:
    API_SERVER_URL + 'api/PersonMaster/ResetTwoFaKeyForPerson',

  //Instance Clone
  API_CLONE_INSTANCE_DETAIL: API_SERVER_URL + 'api/Instance/CloneInstance',

  //WegoAdmin
  API_GET_WEGOADMIN_LIST: API_SERVER_URL + 'api/WegoAdmin/GetWegoAdminList',
  API_GET_WEGOADMIN_PERSON_LIST: API_SERVER_URL + 'api/WegoAdmin/GetPersonList',
  API_GET_WEGOADMIN: API_SERVER_URL + 'api/WegoAdmin/UpdateWegoAdmin',
  API_DELETE_WEGOADMIN: API_SERVER_URL + 'api/WegoAdmin/DeleteWegoAdmin',
  API_EXPORT_WEGOADMIN_LIST: API_SERVER_URL + 'api/WegoAdmin/ExportWegoAdmin',
  API_GET_INACTIVEWEGOADMIN:
    API_SERVER_URL + 'api/WegoAdmin/InActiveWegoAdminMaster',
  API_RESET_TWOFA_COOKIES_WEGOADMIN:
    API_SERVER_URL + 'api/WegoAdmin/ResetWegoAdminTwoFaCookies',
  API_RESET_TWOFA_KEYS_WEGOADMIN:
    API_SERVER_URL + 'api/WegoAdmin/ResetWeGoAdminTwoFaKeys',
  API_UPDATE_WEGOADMIN_TWOFA_VALIDITY:
    API_SERVER_URL + 'api/WegoAdmin/UpdateTwoFAValidityDays',

    API_GET_TWOFA_KEYS_WEGOADMIN:
    API_SERVER_URL + 'api/WegoAdmin/GetTwoFAValidityDays',

  //CompanyMaster
  API_GET_COMPANY_LIST: API_SERVER_URL + 'api/CompanyMaster/GetAllCompanyList',
  API_GET_COMPNAY_BY_HASH:
    API_SERVER_URL + 'api/CompanyMaster/GetCompanyByHashID',
  API_GET_COMPANY_BASIC_DETAIL:
    API_SERVER_URL + 'api/CompanyMaster/GetCompanyBasicDetail',
  API_POST_COMPANY_DETAIL:
    API_SERVER_URL + 'api/CompanyMaster/UpdateCompanyMaster',
  API_UPDATE_COMPANY_CONTACT_PERSON:
    API_SERVER_URL + 'api/CompanyMaster/UpdateCompanyContactPerson',
  API_EXPORT_COMPANY_LIST: API_SERVER_URL + 'api/CompanyMaster/ExportCompany',
  API_POST_DELETE_COMPANY:
    API_SERVER_URL + 'api/CompanyMaster/DeleteCompanyMasterList',
  API_REMOVE_COMPANY_CONTACT_PERSON:
    API_SERVER_URL + 'api/CompanyMaster/RemoveCompanyContactPerson',
  API_GET_GEOFENCE: API_SERVER_URL + 'api/CompanyMaster/IsGeofenceEnabled',
  API_GET_LOCATION_MODE:
    API_SERVER_URL + 'api/CompanyMaster/IsHomeLocationEnabled',
  API_GET_ODOMETER_CONFIG:
    API_SERVER_URL + 'api/CompanyMaster/IsOdometerConfigEnabled',
  API_GET_INSTANCE_LANGUAGE_BY_COMPANY:
    API_SERVER_URL + 'api/CompanyMaster/GetInstanceLanguage',
  API_GET_COMPANY_BY_INSTANCE:
    API_SERVER_URL + 'api/CompanyMaster/GetCompanyByInstance',
  API_GET_COMPANY_BY_INSTANCEHASHID:
    API_SERVER_URL +
    'api/CompanyMaster/GetDropdownCompanyListForPrePostTripQuestion',
  API_GET_DROPDOWN_COMPANY_LIST_VEHICLEOCCUPANCYREPORT:
    API_SERVER_URL +
    'api/CompanyMaster/GetDropdownCompanyListForVehicleOccupancyReport',
  API_GET_DROPDOWN_COMPANY_LIST_REVENUEVEHICLEREPORT:
    API_SERVER_URL +
    'api/CompanyMaster/GetDropdownCompanyListForRevenueVehicleReport',
  API_GET_DROPDOWN_COMPANY_LIST_TRIPDATAREPORT:
    API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListFoTripDataReport',
  API_GET_DROPDOWN_COMPANY_LIST_MAINTENCEPLANNINGREPORT:
    API_SERVER_URL +
    'api/CompanyMaster/GetDropdownCompanyListForMaintencePlanningReport',
  API_GET_DROPDOWN_COMPANY_LIST_SVG:
    API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForSVG',
  API_GET_DROPDOWN_COMPANY_LIST_ORGANIZATION:
    API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForOrganization',
  API_GET_DROPDOWN_COMPANY_LIST_VEHICLE:
    API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForVehicle',
  API_GET_DROPDOWN_COMPANY_LIST_BRANDING:
    API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForBranding',
  API_GET_DROPDOWN_COMPANY_LIST_DASHBOARD:
    API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForDashboard',
  API_GET_DROPDOWN_COMPANY_LIST_TEMPLATE:
    API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForTemplate',
  API_GET_DROPDOWN_COMPANY_LIST_INVOICE_UPDATE:
    API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForInvoiceUpdate',
  API_GET_DROPDOWN_COMPANY_LIST_PRE_POST_TRIP_QUESTION:
    API_SERVER_URL +
    'api/CompanyMaster/GetDropdownCompanyListForPrePostTripQuestion',
  API_GET_DROPDOWN_COMPANY_LIST_FOR_COST_CENTER_REPORT:
    API_SERVER_URL +
    'api/CompanyMaster/GetDropdownCompanyListForCostCenterReport',
  API_GET_DROPDOWN_COMAPNY_LIST_KICKBACKREPORT:
    API_SERVER_URL +
    'api/CompanyMaster/GetDropdownCompanyListForKickBackReport',
  API_GET_DROPDOWN_COMPANY_LIST_TERMS_AND_CONDITION:
    API_SERVER_URL +
    'api/CompanyMaster/GetDropdownCompanyListForTermsAndCondition',
  API_GET_DROPDOWN_COMPANY_LIST_BY_INSTANCE_LIST_TERMS_AND_CONDITION:
    API_SERVER_URL +
    'api/CompanyMaster/GetDropdownCompanyListForTermsCondByInstanceList',

  API_RESET_TWOFA_COOKIES_COMPANY:
    API_SERVER_URL + 'api/CompanyMaster/ResetCompanyAdminTwoFaCookies',
  API_RESET_TWOFA_KEYS_COMPANY:
    API_SERVER_URL + 'api/CompanyMaster/ResetCompanyAdminTwoFaKeys',

  API_GET_TWOFA_ENABLED_COMPANY:
    API_SERVER_URL + 'api/CompanyMaster/IsTwoFAEnabledForInstanceByCompany',

  //CompanyAdmin
  API_GET_COMPANY_ADMIN_LIST:
    API_SERVER_URL + 'api/CompanyAdmin/GetAllCompanyAdminListByCompany',
  API_GET_PERSON_LIST_BY_COMPANY_ID:
    API_SERVER_URL + 'api/CompanyAdmin/GetPersonListForCompanyAdmin',
  API_GET_COMPANY_CONATACT_PERSON_LIST:
    API_SERVER_URL + 'api/CompanyMaster/GetPersonListForContactPerson',
  API_POST_COMPANY_ADMIN_DETAIL:
    API_SERVER_URL + 'api/CompanyAdmin/UpdateCompanyAdmin',
  API_EXPORT_COMPANY_ADMIN_LIST:
    API_SERVER_URL + 'api/CompanyAdmin/ExportCompanyAdminListByCompany',
  API_POST_DELETE_COMPANY_ADMIN:
    API_SERVER_URL + 'api/CompanyAdmin/DeleteCompanyAdminMasterList',
  API_GET_INACTIVE_COMPANY_ADMIN:
    API_SERVER_URL + 'api/CompanyAdmin/InActiveCompanyAdmin',

  //ErrorLog
  // API_GET_ERRORLOG_LIST: API_SERVER_URL + 'api/ErrorLog/GetErrorLogList',
  // API_GET_EXPORT_ERRORLOG: API_SERVER_URL + 'api/ErrorLog/ExportErrorLog',
  API_GET_ERRORLOG_LIST: API_SERVER_URL + 'api/ErrorReporting/GetEventLog',
  API_GET_EXPORT_ERRORLOG: API_SERVER_URL + 'api/ErrorReporting/ExportEventLog',
  API_GET_DROPDOWN_ERRORLOGTYPE_LIST:
    API_SERVER_URL + 'api/ErrorReporting/GetDropdownLogTypeListForErroLog',
  API_GET_DROPDOWN_ERRORLOGCOMPONENT_LIST:
    API_SERVER_URL + 'api/ErrorReporting/GetDropdownComponentListForErroLog',

  //ErrorEscalation
  API_GET_ErrorEscalation_LIST:
    API_SERVER_URL + 'api/ErrorEscalation/GetErrorEscalationConfigList',
  API_GET_EXPORT_ErrorEscalation:
    API_SERVER_URL + 'api/ErrorEscalation/ExportErrorEscalation',
  API_GET_DELETE_ERRORESCALATION:
    API_SERVER_URL + 'api/ErrorEscalation/DeleteErrorEscalation',
  API_GET_ERRORESCALATION_BY_HASH:
    API_SERVER_URL + 'api/ErrorEscalation/GetErrorEsclationByHashID',
  API_POST_ERRORESCALATION_DETAIL:
    API_SERVER_URL + 'api/ErrorEscalation/UpdateErrorEsclationConfig',
  API_GET_DROPDOWN_ERRORESCLATION_LIST:
    API_SERVER_URL + 'api/ErrorEscalation/GetErrorEsclationDropDownData',
  API_GET_INSTANCEADMINLISTBYINSTANCE_LIST:
    API_SERVER_URL + 'api/Instance/GetInstanceAdminListByInstance',
  API_GET_CUSTOMERADMINLISTBYCUSTOMER_LIST:
    API_SERVER_URL + 'api/Customer/GetCustomerAdminListByCustomer',
  API_GET_DROPDOWN_INSTANCE_LIST_ERRORESCLATION:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForErrorEsclation',
  API_GET_DROPDOWN_INSTANCE_LIST_ERRORLOG:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForErrorLog',

  // Interface Status
  //API_GET_INTERFACESTATUS_LIST: API_SERVER_URL + 'api/InterfaceStatus/GetInterfaceStatusList',
  API_GET_INTERFACESTATUS_LIST:
    API_SERVER_URL + 'api/CarwiseInterfaceStatus/GetCarwiseInterfaceStatus',
  //API_GET_EXPORT_INTERFACESTATUS: API_SERVER_URL + 'api/InterfaceStatus/ExportInterfaceStatus',
  API_GET_EXPORT_INTERFACESTATUS:
    API_SERVER_URL + 'api/CarwiseInterfaceStatus/ExportCarwiseStatus',

  //OrganizationMaster
  API_GET_ORGANIZATION_LIST:
    API_SERVER_URL + 'api/OrganizationMaster/GetAllOrganizationList',
  API_POST_ORGANIZATION_BLOCKUNBLOCK:
    API_SERVER_URL + 'api/OrganizationMaster/BlockUnblockOrganization',
  API_GET_ORGANIZATION_BY_HASH:
    API_SERVER_URL + 'api/OrganizationMaster/GetOrganizationByHashID',
  API_GET_ORGANIZATION_BASIC_DETAIL:
    API_SERVER_URL + 'api/OrganizationMaster/GetOrganizationBasicDetail',
  API_POST_ORGANIZATION_DETAIL:
    API_SERVER_URL + 'api/OrganizationMaster/UpdateOrganizationMaster',
  API_UPDATE_ORGANIZATION_CONTACT_PERSON:
    API_SERVER_URL + 'api/OrganizationMaster/UpdateOrganizationContactPerson',
  API_EXPORT_ORGANIZATION_LIST:
    API_SERVER_URL + 'api/OrganizationMaster/ExportOrganization',
  API_POST_DELETE_ORGANIZATION:
    API_SERVER_URL + 'api/OrganizationMaster/DeleteOrganizationMasterList',
  API_REMOVE_ORGANIZATION_CONTACT_PERSON:
    API_SERVER_URL + 'api/OrganizationMaster/RemoveOrganizationContactPerson',
  API_EXPORT_ORGANIZATION_DRIVER_LIST:
    API_SERVER_URL + 'api/OrganizationMaster/ExportOrganizationDriver',
  API_GET_ORGANIZATION_FOR_BATCH_UPLOAD:
    API_SERVER_URL + 'api/OrganizationMaster/GetOrgazationsForBatchUpload',
  API_GET_ORGANIZATION_DRIVER_LIST:
    API_SERVER_URL + 'api/OrganizationMaster/GetAllOrganizationDriver',
  //API_GET_ORGANIZATION_LIST_BY_INSTANCE: API_SERVER_URL + 'api/OrganizationMaster/GetOrganizationByInstanceID',
  API_GET_ORGANIZATION_COMPANY_LIST:
    API_SERVER_URL + 'api/OrganizationMaster/GetAllCompanyList',
  API_GET_DROPDOWN_ORGANIZATION_LIST_SIGNUPCONFIG:
    API_SERVER_URL +
    'api/OrganizationMaster/GetDropdownOrganizationListForSignUpConfig',
  API_GET_DROPDOWN_ORGANIZATION_LIST_BATCHUPLOADPERSON:
    API_SERVER_URL +
    'api/OrganizationMaster/GetDropdownOrganizationListForBatchUploadPerson',
  API_GET_DROPDOWN_ORGANIZATION_LIST_TEMPLATE:
    API_SERVER_URL +
    'api/OrganizationMaster/GetDropdownOrganizationListForTemplate',
  API_GET_DROPDOWN_ORGANIZATION_LIST_BY_SVG_KICK_BACK_REPORT:
    API_SERVER_URL +
    'api/OrganizationMaster/GetDropdownOrganizationListForKickBackReport',
  API_GET_DROPDOWN_ORGANIZATION_LIST_BY_SVG_TRIP_DATA_REPORT:
    API_SERVER_URL +
    'api/OrganizationMaster/GetDropdownOrganizationListForTripDataReport',
  API_GET_DROPDOWN_ORGANIZATION_LIST_COST_CENTER_REPORT:
    API_SERVER_URL +
    'api/OrganizationMaster/GetDropdownOrganizationListForCostCenterReport',
  API_GET_ORGANIZATION_GDPR_SETTINGS:
    API_SERVER_URL + 'api/OrganizationMaster/GetOrganizationGDPRSettings',
  API_GET_DROPDOWN_ORGANIZATION_LIST_TERMS_AND_CONDITION:
    API_SERVER_URL +
    'api/OrganizationMaster/GetDropdownOrganizationListForTermsAndCondition',
  API_GET_DROPDOWN_ORGANIZATION_LIST_BY_COMPANY_LIST_TERMS_AND_CONDITION:
    API_SERVER_URL +
    'api/OrganizationMaster/GetDropdownOrganizationListForTermsCondByCompanyList',
  API_RESET_TWOFA_COOKIES_ORGANIZATION:
    API_SERVER_URL + 'api/OrganizationMaster/ResetOrganizationAdminTwoFaCookies',
  API_RESET_TWOFA_KEYS_ORGANIZATION:
    API_SERVER_URL + 'api/OrganizationMaster/ResetOrganizationAdminTwoFaKeys',
  API_GET_ORGANIZATION_DETAIL:
    API_SERVER_URL + 'api/OrganizationMaster/GetDropdownOrganizationListBySVG',


  //ORGANIZATIONADMIN
  API_GET_ORGANIZATION_ADMIN_LIST:
    API_SERVER_URL +
    'api/OrganizationAdmin/GetAllOrganizationAdminListByOrganization',
  API_GET_PERSON_LIST_BY_ORGANIZATION_ID:
    API_SERVER_URL + 'api/OrganizationAdmin/GetPersonListForOrganizationAdmin',
  API_GET_ORGANIZATION_CONATACT_PERSON_LIST:
    API_SERVER_URL + 'api/OrganizationMaster/GetPersonListForContactPerson',
  API_POST_ORGANIZATION_ADMIN_DETAIL:
    API_SERVER_URL + 'api/OrganizationAdmin/UpdateOrganizationAdmin',
  API_EXPORT_ORGANIZATIONY_ADMIN_LIST:
    API_SERVER_URL +
    'api/OrganizationAdmin/ExportOrganizationAdminListByOrganization',
  API_POST_DELETE_ORGANIZATION_ADMIN:
    API_SERVER_URL + 'api/OrganizationAdmin/DeleteCompanyAdminMasterList',
  API_GET_INACTIVE_ORGANIZATION_ADMIN:
    API_SERVER_URL + 'api/OrganizationAdmin/InActiveOrganizationAdmin',

  //Driver Dashboard
  API_GET_UPCOMING_BOOKING_LIST:
    API_SERVER_URL + 'api/DriverDashboard/GetUpcomingBooking',

  // Admin Dashboard
  API_GET_VEHICLE_WITH_STATUS:
    API_SERVER_URL + 'api/AdminDashboard/GetVehicleWithStatus',
  API_GET_WINDOWS_SERVICE_STATUS:
    API_SERVER_URL + 'api/AdminDashboard/GetWindowsServiceStatus',
  API_GET_PRIORITY_FOR_ISSUE:
    API_SERVER_URL + 'api/AdminDashboard/GetPriorityForIssues',
  API_EXPORT_VEHICLE_WITH_STATUS_XLS:
    API_SERVER_URL + 'api/AdminDashboard/ExportVehicleWithStatusExcel',
  API_GET_ONLINE_PAYMENT_SERVICE_STATUS:
    API_SERVER_URL + 'api/AdminDashboard/GetPaymentServiceStatus',

  //Instance
  API_GET_INSTANCE_LIST: API_SERVER_URL + 'api/Instance/GetAllInstance',
  API_GET_INSTANCE_BY_HASH: API_SERVER_URL + 'api/Instance/GetInstanceByHashID',
  API_GET_INSTANCE_BY_COMPANY_HASH: API_SERVER_URL + 'api/Instance/GetInstanceByCompanyHashID',
  API_GET_INSTANCE_BASIC_DETAIL:
    API_SERVER_URL + 'api/Instance/GetInstanceBasicDetail',
  API_POST_INSTANCE_DETAIL: API_SERVER_URL + 'api/Instance/UpdateInstance',
  API_EXPORT_INSTANCE_LIST: API_SERVER_URL + 'api/Instance/ExportInstance',
  API_DELETE_INSTANCE: API_SERVER_URL + 'api/Instance/DeleteInstance',
  API_GET_IMPORT_ALLOWED_INSTANCE_LIST:
    API_SERVER_URL + 'api/Instance/GetImportAllowedInstance',
  API_GET_IMPORT_ALLOWED_TO_USER:
    API_SERVER_URL + 'api/Instance/CheckIsAllowToImportPerson',
  API_GET_ODOMETER_ENABLED: API_SERVER_URL + 'api/Instance/IsOdometerEnabled',
  API_GET_BATCH_UPLOAD_ALLOW_TO_USER:
    API_SERVER_URL + 'api/Instance/CheckIsAllowToBatchUploadPerson',
  API_GET_BATCH_UPLOAD_DETAIL_BY_HASH:
    API_SERVER_URL + 'api/Instance/GetBatchUploadDetailFromInstanceByHashID',
  API_GET_INSTANCES_FOR_BATCH_UPLOAD:
    API_SERVER_URL + 'api/Instance/GetInstancesForBatchUpload',
  API_GET_DIRECTDEBIT_ENABLED_COMPANY:
    API_SERVER_URL + 'api/Instance/IsDirectDebitEnabledForCompany',
  API_GET_PAYMENTSETTING_REQUIRED_ON_INSTANCE:
    API_SERVER_URL + 'api/Instance/PaymentSettingRequired',
  API_GET_DIRECTDEBIT_ENABLED:
    API_SERVER_URL + 'api/Instance/IsDirectDebitEnabled',
  API_GET_INSTANCE_LANGUAGE:
    API_SERVER_URL + 'api/Instance/GetInstanceLanguage',
  API_GET_NIF_NUMBER_ENABLED:
    API_SERVER_URL + 'api/Instance/IsNIFNumberEnabled',
  API_GET_COUNTRYCODE: API_SERVER_URL + 'api/Instance/GetCountryCode',
  API_GET_DROPDOWN_INSTANCE_LIST_VEHICLEOCCUPANCYREPORT:
    API_SERVER_URL +
    'api/Instance/GetDropdownInstanceListForVehicleOccupancyReport',
  API_GET_DROPDOWN_INSTANCE_LIST_REVENUEVEHICLEREPORT:
    API_SERVER_URL +
    'api/Instance/GetDropdownInstanceListForRevenueVehicleReport',
  API_GET_DROPDOWN_INSTANCE_LIST_TRIPDATAREPORT:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListFoTripDataReport',
  API_GET_DROPDOWN_INSTANCE_LIST_MAINTENCEPLANNINGREPORT:
    API_SERVER_URL +
    'api/Instance/GetDropdownInstanceListForMaintencePlanningReport',
  API_GET_DROPDOWN_INSTANCE_LIST_PERSON:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListPerson',
  API_GET_DROPDOWN_INSTANCE_LIST_CATEGORY_ATTRIBUTE:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForCategoryAttribute',
  API_GET_DROPDOWN_INSTANCE_LIST_VEHICLE_ATTRIBUTE:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForVehicleAttribute',
  API_GET_DROPDOWN_INSTANCE_LIST_TEMPLATE:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForTemplate',
  API_GET_DROPDOWN_INSTANCE_LIST_COMPANY:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListCompany',
  API_GET_DROPDOWN_INSTANCE_LIST_ORGANIZATION:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForOrganization',
  API_GET_DROPDOWN_INSTANCE_LIST_BRANDING:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForBranding',
  API_GET_DROPDOWN_INSTANCE_LIST_DASHBOARD:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForDashboard',
  API_GET_DROPDOWN_INSTANCE_LIST_TERMSANDCONDITIONS:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForTermsAndCondtions',
  API_GET_DROPDOWN_INSTANCE_LIST_INVOICE_UPDATE:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForInvoiceUpdate',
  API_GET_DROPDOWN_INSTANCE_LIST_KICKBACKREPORT:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForKickBackReport',
  API_GET_DROPDOWN_INSTANCE_TIMEZONE_LIST:
    API_SERVER_URL + 'api/Instance/GetDropdownTimeZoneList',
  API_GET_DROPDOWN_INSTANCE_LIST_FOR_COST_CENTER_REPORT:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForCostCenterReport',
  API_GET_DROPDOWN_INSTANCE_LIST_FOR_PRE_POST_TRIP_QUESTION:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListPrePostTripQuestion',
  API_RESET_TWOFA_COOKIES_INSTANCE:
    API_SERVER_URL + 'api/Instance/ResetInstanceAdminTwoFaCookies',
  API_RESET_TWOFA_KEYS_INSTANCE:
    API_SERVER_URL + 'api/Instance/ResetInstanceAdminTwoFaKeys',
  API_GET_TWOFA_ENABLED:
    API_SERVER_URL + 'api/Instance/IsTwoFAEnabledForInstance',
  //VehicleMaster
  API_GET_VEHICLE_LIST: API_SERVER_URL + 'api/VehicleMaster/GetAllVehicleList',
  API_GET_VEHICLE_BY_HASH:
    API_SERVER_URL + 'api/VehicleMaster/GetVehicleByHashID',
  API_POST_VEHICLE_DETAIL:
    API_SERVER_URL + 'api/VehicleMaster/UpdateVehicleMaster',
  API_Block_UNBLOCK_VEHICLE:
    API_SERVER_URL + 'api/VehicleMaster/BlockUnblockVehicle',
  API_POST_DELETE_VEHICLES:
    API_SERVER_URL + 'api/VehicleMaster/DeleteVehicleList',
  API_EXPORT_VEHICLE_LIST:
    API_SERVER_URL + 'api/VehicleMaster/ExportVehicleList',
  //API_GET_VEHICLE_SVG_LIST: API_SERVER_URL + 'api/VehicleMaster/GetAllVehicleSVGList',
  API_EXPORT_VEHICLE_SVG_LIST:
    API_SERVER_URL + 'api/VehicleMaster/ExportVehicleSVGList',
  API_EXPORT_VTSVEHICLE_SVG_LIST:
    API_SERVER_URL + 'api/VehicleMaster/ExportVtsVehicleList',
  API_GET_VEHICLE_LIST_BY_SVGID:
    API_SERVER_URL + 'api/VehicleMaster/GetVehicleListBySVGID',
  API_POST_VEHICLE_BLOCK:
    API_SERVER_URL + 'api/VehicleMaster/BlockUnblockVehicle',
  API_GET_AFFECTEDBOOKING:
    API_SERVER_URL + 'api/VehicleMaster/GetAffectedBookings',
  API_GET_VTS_VEHICLE_LIST:
    API_SERVER_URL + 'api/VehicleMaster/GetVTSVehicleList',
  API_POST_VTSVEHICLE_DETAIL:
    API_SERVER_URL + 'api/VehicleMaster/VtsVehicleUpdate',
  API_GET_VTSVEHICLE_LIST:
    API_SERVER_URL + 'api/VehicleMaster/GetAllVtsVehicleList',
  API_GET_VTSVEHICLE_BY_HASH:
    API_SERVER_URL + 'api/VehicleMaster/GetVtsVehicleByHashID',
  API_UPDATE_REPORT_DAMAGE_STATUS:
    API_SERVER_URL + 'api/ReportDamage/UpdateReportDamageStatus',
  API_GET_VEHICLE_FUTURE_BOOKING_LIST:
    API_SERVER_URL + 'api/VehicleMaster/GetVehicleFutureBookingList',
  API_POST_VEHICLE_INFO: API_SERVER_URL + 'api/VehicleMaster/UpdateVehicleInfo',
  API_GET_DROPDOWN_VEHICLE_LIST_VEHICLEOCCUPANCYREPORT:
    API_SERVER_URL +
    'api/VehicleMaster/GetDropdownVehicleListForVehicleOccupancyReport',
  API_GET_DROPDOWN_VEHICLE_LIST_REVENUEVEHICLEREPORT:
    API_SERVER_URL +
    'api/VehicleMaster/GetDropdownVehicleListForRevenueVehicleReport',
  API_GET_DROPDOWN_VEHICLE_LIST_TRIPDATAREPORT:
    API_SERVER_URL + 'api/VehicleMaster/GetDropdownVehicleListFoTripDataReport',
  API_GET_DROPDOWN_VEHICLE_LIST_MAINTENCEPLANNINGREPORT:
    API_SERVER_URL +
    'api/VehicleMaster/GetDropdownVehicleListForMaintencePlanningReport',
  API_GET_VEHICLE_DROPDOWN_LIST_BY_SVGID:
    API_SERVER_URL +
    'api/VehicleMaster/GetDropdownVehicleListForDriverBookingAgenda',
  API_GET_DROPDOWN_VEHICLE_LIST_KICKBACKREPORT:
    API_SERVER_URL +
    'api/VehicleMaster/GetDropdownVehicleListForKickBackReport',
  API_GET_VEHICLE_LIST_FOR_COST_CENTER_REPORT:
    API_SERVER_URL + 'api/VehicleMaster/GetAllVehicleListForCostCenterReport',

  //SharedVehicleGroup
  API_GET_DROPDOWN_SVG_LIST_TERMS_AND_CONDITION:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetSVGListForTermsAndCondition',
  API_GET_SHAREDVEHICLEGROUP_DETAIL:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetAllSharedVehicleGroup',
  API_GET_SHAREDVEHICLEGROUP_BY_HASH:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetShareVehicleGroupByHashID',
  API_GET_SHAREDVEHICLEGROUP_BASIC_DETAIL:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetSharedVehicleGroupBasicDetail',
  API_POST_SHAREDVEHICLEGROUP_DETAIL:
    API_SERVER_URL + 'api/SharedVehicleGroup/UpdateSharedvehiclegroup',
  API_EXPORT_SHAREDVEHICLEGROUP_LIST:
    API_SERVER_URL + 'api/SharedVehicleGroup/ExportSharedVehicleGroup',
  API_POST_DELETE_SVG_VEHICLE_DETAIL:
    API_SERVER_URL + 'api/SharedVehicleGroup/DeleteSharedVehicleGroupList',
  API_GET_SVGVEHICLEGLIST:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetAllGroupVehicle',
  API_GET_VEHICLEGROUP_LIST:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetVehicleListForGroup',
  API_GET_INACTIVE_SHAREDVEHICLEGROUP:
    API_SERVER_URL + 'api/SharedVehicleGroup/InActiveSharedVehicleGroup',
  API_GET_SVGDRIVERGLIST:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetAllGroupDriver',
  API_GET_DROPDOWN_SVG_LIST_VEHICLEOCCUPANCYREPORT:
    API_SERVER_URL +
    'api/SharedVehicleGroup/GetDropdownSVGListForVehicleOccupancyReport',
  API_GET_DROPDOWN_SVG_LIST_REVENUEVEHICLEREPORT:
    API_SERVER_URL +
    'api/SharedVehicleGroup/GetDropdownSVGListForRevenueVehicleReport',
  API_GET_DROPDOWN_SVG_LIST_TRIPDATAREPORT:
    API_SERVER_URL +
    'api/SharedVehicleGroup/GetDropdownSVGListFoTripDataReport',
  API_GET_DROPDOWN_SVG_LIST_MAINTENCEPLANNINGREPORT:
    API_SERVER_URL +
    'api/SharedVehicleGroup/GetDropdownSVGListForMaintencePlanningReport',
  API_GET_DROPDOWN_SVG_LIST_DASHBOARD:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetDropdownSVGListForDashboard',
  API_GET_DROPDOWN_DRIVER_LIST:
    API_SERVER_URL +
    'api/SharedVehicleGroup/GetDropdownDriverListForTripDataReport',
  API_GET_DROPDOWN_SVG_LIST_BOOKING_AGENDA:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetSVGListForDriverBookingAgenda',
  API_GET_DROPDOWN_SVG_LIST_TEMPLATE:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetSVGListForTemplate',
  API_GET_DROPDOWN_SVG_LIST_KICK_BACK_REPORT:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetSVGListForKickBackReport',
  API_GET_DROPDOWN_SVG_LIST_PRE_POST_TRIP_QUESTION:
    API_SERVER_URL + 'api/SharedVehicleGroup/GetSVGListForPrePostTripQuestion',
  API_GET_DROPDOWN_SVG_LIST_BY_ORG_LIST_TERMS_AND_CONDITION:
    API_SERVER_URL +
    'api/SharedVehicleGroup/GetDropdownSharedVehicelGroupListForTermsCondByOrgList',
  API_RESET_TWOFA_COOKIES_SVG:
    API_SERVER_URL + 'api/SharedVehicleGroup/ResetSharedvehicleGroupAdminTwoFaCookies',
  API_RESET_TWOFA_KEYS_SVG:
    API_SERVER_URL + 'api/SharedVehicleGroup/ResetSharedvehicleGroupAdminTwoFaKeys',

  //SharedVehicleGroupAdmin
  API_GET_SHAREDVEHICLEGROUPADMIN_DETAIL:
    API_SERVER_URL +
    'api/SharedVehicleGroupAdmin/GetAllSharedVehicleGroupAdmin',
  API_GET_PERSON_LIST_BY_SHAREDVEHICLEGROUP_ID:
    API_SERVER_URL +
    'api/SharedVehicleGroupAdmin/GetPersonListForSharedVehicleGroupAdmin',
  API_POST_SHAREDVEHICLEGROUP_ADMIN_DETAIL:
    API_SERVER_URL +
    'api/SharedVehicleGroupAdmin/UpdateSharedVehicleGroupAdmin',
  API_EXPORT_SHAREDVEHICLEGROUPADMIN_LIST:
    API_SERVER_URL +
    'api/SharedVehicleGroupAdmin/ExportSharedVehicleGroupAdmin',
  API_POST_DELETE_SHAREDVEHICLEGROUP_ADMIN:
    API_SERVER_URL +
    'api/SharedVehicleGroupAdmin/DeleteSharedVehicleGroupAdminList',
  API_GET_INACTIVE_SHAREDVEHICLEGROUP_ADMIN:
    API_SERVER_URL +
    'api/SharedVehicleGroupAdmin/InActiveSharedVehicleGroupAdmin',

  //SharedVehicleDriver
  API_GET_SVG_LIST_FOR_DRIVERS:
    API_SERVER_URL + 'api/SharedVehicleDriver/GetSVGListForDrivers',
  API_POST_SVG_DRIVER_DETAIL:
    API_SERVER_URL + 'api/SharedVehicleDriver/UpdateSharedVehicleDriver',
  API_POST_DELETE_DRIVER_SVG:
    API_SERVER_URL + 'api/SharedVehicleDriver/DeleteSharedVehicleDriverList',
  API_GET_UNSUBSCRIBE_DRIVER_SVG:
    API_SERVER_URL + 'api/SharedVehicleDriver/UnsubscribeDriver',
  API_GET_AFFECTED_SUBSCRIPTION_BOOKING:
    API_SERVER_URL + 'api/SharedVehicleDriver/GetAffectedSubscriptionBookings',
  API_POST_SVG_DETAIL_FOR_BATCHUPLOAD:
    API_SERVER_URL + 'api/SharedVehicleDriver/GetSVGListForBatchUpload',
  API_CHECK_BOOKING_RUNNING_STATUS:
    API_SERVER_URL + 'api/SharedVehicleDriver/CheckRunningBookingStatus',

  //VehicleGroupMapping
  API_GET_SVG_LIST_FOR_VEHICLE:
    API_SERVER_URL + 'api/VehicleGroupMapping/GetSVGListForVehicle',
  API_POST_SVG_VEHICLE_DETAIL:
    API_SERVER_URL + 'api/VehicleGroupMapping/UpdateVehicleGroupMapping',
  API_POST_DELETE_VEHICLE_SVG:
    API_SERVER_URL + 'api/VehicleGroupMapping/DeleteVehicleSVGList',

  //DriverMaster
  API_GET_DRIVER_LIST: API_SERVER_URL + 'api/DriverMaster/GetAllDriverList',
  API_GET_ACTIVE_DRIVER_LIST:
    API_SERVER_URL + 'api/DriverMaster/GetActiveDriverList',
  API_GET_DRIVER_SVG_LIST:
    API_SERVER_URL + 'api/DriverMaster/GetAllDriverSVGList',
  API_GET_DRIVER_BY_HASH: API_SERVER_URL + 'api/DriverMaster/GetDriverByHashID',
  API_POST_DRIVER_DETAIL:
    API_SERVER_URL + 'api/DriverMaster/UpdateDriverMaster',
  API_INACTIVE_DRIVER: API_SERVER_URL + 'api/DriverMaster/InActiveDriverMaster',
  API_GET_PERSON_LIST_BY_PERSON_ID:
    API_SERVER_URL + 'api/DriverMaster/GetPersonListForDrivers',
  API_EXPORT_DRIVER_LIST: API_SERVER_URL + 'api/DriverMaster/ExportDriverList',
  API_EXPORT_DRIVER_SVG_LIST:
    API_SERVER_URL + 'api/DriverMaster/ExportDriverSVGList',
  // API_POST_DELETE_DRIVER_LIST: API_SERVER_URL + 'api/DriverMaster/DeleteDriverList',
  API_POST_DRIVER_INACTIVE:
    API_SERVER_URL + 'api/DriverMaster/InActiveDriverMaster',
  API_POST_DRIVER_REMOVELICENSEBIRTHDATE:
    API_SERVER_URL + 'api/DriverMaster/RemoveDriverLicense',
  API_GET_CURRENT_DRIVER:
    API_SERVER_URL + 'api/DriverMaster/GetCurrentDriverDetail',
  API_GET_SELECTED_DRIVER:
    API_SERVER_URL + 'api/DriverMaster/GetSelectedDriverDetailByDriverId',
  API_GET_DRIVER_SUBSCRIPTION_DETAIL:
    API_SERVER_URL + 'api/DriverMaster/GetDriverSubscriptionDetail',
  API_EXPORT_DRIVER_SUBSCRIPTION_LIST:
    API_SERVER_URL + 'api/DriverMaster/ExportDriverSubscription',
  API_EXPORT_SVG_DRIVER_LIST:
    API_SERVER_URL + 'api/SharedVehicleGroup/ExportSVGDriverList',
  API_GET_SUBSCRIPTION_DETAIL_BY_SVGDRIVER_HASH:
    API_SERVER_URL + 'api/DriverMaster/GetDriverSubscriptionDetailByHash',

  //DriverTerms
  API_GET_DRIVERTERMS_DETAIL:
    API_SERVER_URL + 'api/DriverTerms/GetDriverTermsByDriverHashId',
  API_POST_DRIVERTERMS_DETAIL:
    API_SERVER_URL + 'api/DriverTerms/UpdateDriverTerm',
  // API_GET_DRIVERTERMSFILE: API_SERVER_URL + 'api/DriverTerms/Test',

  //VehicleAttribute
  API_GET_VEHICLEATTRIBUTE_DETAIL:
    API_SERVER_URL + 'api/VehicleAttribute/GetAllVehicleAttribute',
  API_GET_VEHICLEATTRIBUTE_BY_HASH:
    API_SERVER_URL + 'api/VehicleAttribute/GetVehicleAttributeByHashID',
  API_POST_VEHICLEATTRIBUTE_DETAIL:
    API_SERVER_URL + 'api/VehicleAttribute/UpdateVehicleAttribute',
  API_GET_VEHICLEATTRIBUTECATEGORY_DETAIL:
    API_SERVER_URL +
    'api/VehicleAttributeCategory/GetAllVehicleAttributeCategory',
  API_EXPORT_VEHICLEATTRIBUTE_LIST:
    API_SERVER_URL + 'api/VehicleAttribute/ExportVehicleAttribute',
  API_GET_VEHICLEATTRIBUTE_BY_COMPANY:
    API_SERVER_URL + 'api/VehicleAttribute/GetVehicleAttributeForCompany',

  //Contract Type Group
  API_GET_CONTRACT_TYPE_GROUP_LIST:
    API_SERVER_URL +
    'api/ContractTypeGroup/GetContractTypeGroupBySharedVehicleGroup',
  API_EXPORT_CONTRACT_TYPE_GROUP_LIST:
    API_SERVER_URL +
    'api/ContractTypeGroup/ExportContractTypeGroupBySharedVehicleGroup',
  API_GET_UNASSIGN_CONTRACT_TYPE_GROUP_LIST:
    API_SERVER_URL + 'api/ContractTypeGroup/GetUnassignContractTypeGroupName',
  API_POST_ASSIGN_CONTRACT_TYPE_GROUP:
    API_SERVER_URL +
    'api/ContractTypeGroup/AssignContractGroupToSharedVehicleGroup',
  API_GET_CONTRACT_TYPE_GROUP_DETAIL:
    API_SERVER_URL + 'api/ContractTypeGroup/GetContractTypeGroupByHashId',
  API_POST_CONTRACT_TYPE_GROUP_DETAIL:
    API_SERVER_URL + 'api/ContractTypeGroup/UpdateContractTypeGroup',
  API_GET_INACTIVE_REASON:
    API_SERVER_URL + 'api/ContractTypeGroup/GetInActiveReasonByHashID',
  API_GET_INSTANCE_BY_GROUP:
    API_SERVER_URL + 'api/ContractTypeGroup/GetCurrencyByGroup',
  API_GET_DELETE_GROUP:
    API_SERVER_URL + 'api/ContractTypeGroup/DeleteContracttypeGroup',
  API_GET_DROPDOWN_VATSETTING_LIST:
    API_SERVER_URL + 'api/ContractTypeGroup/GetDropdownVatSetting',
  API_GET_VATSETTING_DEFAULT_VALUES:
    API_SERVER_URL + 'api/ContractTypeGroup/GetVatSettingDefaultValues',
  API_GET_CONTRACTTYPEGROUP_BASIC_DETAIL:
    API_SERVER_URL + 'api/ContractTypeGroup/GetContractTypeGroupBasicDetail',
  API_GET_CONTRACT_TYPE_BY_SVGHASHID:
    API_SERVER_URL + 'api/ContractTypeGroup/GetDropdownContractTypeGroup',
  API_GET_DROPDOWN_CTG_LIST_BY_SVG_KICK_BACK_REPORT:
    API_SERVER_URL +
    'api/ContractTypeGroup/GetCTGDropdowonListForKickBackReport',
  API_GET_DROPDOWN_CTG_LIST_BY_SVG_TERMS_AND_CONDITION:
    API_SERVER_URL +
    'api/ContractTypeGroup/GetCTGDropdowonListForTermsAndCondition',

  //Contract Type
  API_GET_CONTRACT_TYPE_LIST:
    API_SERVER_URL + 'api/ContractType/GetAllContractTypeList',
  API_GET_CONTRACT_TYPE_BY_HASH:
    API_SERVER_URL + 'api/ContractType/GetContractTypeByHashID',
  API_POST_CONTRACT_TYPE_DETAIL:
    API_SERVER_URL + 'api/ContractType/UpdateContractTypeMaster',
  API_EXPORT_CONTRACT_TYPE_LIST:
    API_SERVER_URL + 'api/ContractType/ExportContractType',
  API_POST_DELETE_CONTRACT_TYPE:
    API_SERVER_URL + 'api/ContractType/DeleteContractTypeList',
  API_GET_CONTRACT_TYPE_HISTORY:
    API_SERVER_URL + 'api/ContractType/GetContractTypeHistory',
  API_GET_SPECIAL_PERIOD_LIST:
    API_SERVER_URL + 'api/ContractType/GetSpecialPeriods',

  //VehicleAttributeCategory
  //API_GET_VEHICLEATTRIBUTECATEGORY_DETAIL: API_SERVER_URL + 'api/VehicleAttributeCategory/GetAllVehicleAttributeCategory',
  API_GET_VEHICLEATTRIBUTE_CATEGORY_BY_HASH:
    API_SERVER_URL +
    'api/VehicleAttributeCategory/GetVehicleAttributeByCategoryHashID',
  API_POST_VEHICLEATTRIBUTE_CATEGORY_DETAIL:
    API_SERVER_URL +
    'api/VehicleAttributeCategory/UpdateVehicleAttributeCategory',
  API_EXPORT_VEHICLEATTRIBUTECATEGORY_LIST:
    API_SERVER_URL +
    'api/VehicleAttributeCategory/ExportVehicleAttributeCategory',
  API_GET_VEHICLEATTRIBUTECATEGORY_BY_INSTANCE:
    API_SERVER_URL +
    'api/VehicleAttributeCategory/GetVehicleAttributeCategoryByInstance',

  //PersonProfile
  API_GET_PERSONPROFILE_BY_ACTIVATION_CODE:
    API_SERVER_URL + 'api/PersonProfile/GetPersonByActivationCode',
  API_POST_PERSONPROFILE_DETAIL:
    API_SERVER_URL + 'api/PersonProfile/UpdatePersonProfile',

  //ForgotPassword
  API_POST_FORGOTPASSSWORD:
    API_SERVER_URL + 'api/ForgotPassword/SendForgotPassword',
  API_POST_CHANGEPASSSWORD:
    API_SERVER_URL + 'api/ForgotPassword/ChangePassword',
  API_GET_CHECKACTIVATIONCODE:
    API_SERVER_URL + 'api/ForgotPassword/CheckActivationCode',

  //Booking
  API_GET_SCHEDULED_BOOKING_LIST:
    API_SERVER_URL + 'api/BookingMaster/GetScheduledBookingList',
  API_GET_AFFECTED_BOOKING_LIST:
    API_SERVER_URL + 'api/BookingMaster/GetAffectedBookingList',
  API_GET_BOOKING_LIST: API_SERVER_URL + 'api/BookingMaster/GetBookingList',
  API_GET_EDIT_BOOKING: API_SERVER_URL + 'api/BookingMaster/EditBookingDetail',
  API_GET_VEHICLE_OVERVIEW:
    API_SERVER_URL + 'api/BookingMaster/GetVehicleOverview',
  API_GET_BOOKING_OVERVIEW:
    API_SERVER_URL + 'api/BookingMaster/GetBookingOverview',
  API_GET_BOOKING_Details:
    API_SERVER_URL + 'api/BookingMaster/GetBookingDetails',
  API_POST_MAKE_PROVISIONAL_BOOKING:
    API_SERVER_URL + 'api/BookingMaster/MakeProvisionalBooking',
  API_POST_CONFIRM_PROVISIONAL_BOOKING:
    API_SERVER_URL + 'api/BookingMaster/ConfirmProvisionalBooking',
  API_POST_RECURRING_PAYMENT_BOOKING:
    API_SERVER_URL + 'api/BookingMaster/MakeRecurringPaymentForCreateBooking',
  API_CREATE_INITIAL_PAYMENT:
    API_SERVER_URL + 'api/BookingMaster/StartInitialPaymentForCreateBooking',
  API_START_INITIAL_PAYMENT:
    API_SERVER_URL + 'api/BookingMaster/StartInitialPaymentForStartBooking',
  API_GET_CANCEL_PROVISIONAL_BOOKING:
    API_SERVER_URL + 'api/BookingMaster/CancelProvisionalBooking',
  API_GET_BOOKING_OVERVIEW_LIST:
    API_SERVER_URL + 'api/BookingMaster/GetBookingOverViewList',
  API_GET_BOOKING_REQUEST_LIST:
    API_SERVER_URL + 'api/BookingMaster/GetBookingRequestList',
  API_GET_BOOKING_History_LIST:
    API_SERVER_URL + 'api/DriverMaster/GetBookingHistroyForDriver',
  API_EXPORT_BOOKING_HISTORY_LIST:
    API_SERVER_URL + 'api/DriverMaster/ExportBookingHistroyForDriver',
  API_EXPORT_BOOKING_LIST: API_SERVER_URL + 'api/BookingMaster/ExportBookings',
  API_EXPORT_BOOKING_REQUEST_LIST:
    API_SERVER_URL + 'api/BookingMaster/ExportBookingRequest',
  API_POST_CANCEL_BOOKINGS_LIST:
    API_SERVER_URL + 'api/BookingMaster/CancelBooking',
  API_POST_REVOKE_ABORT_BOOKING:
    API_SERVER_URL + 'api/BookingMaster/RevokeOrAbortBooking',
  API_POST_MAKE_SPECIAL_BOOKING:
    API_SERVER_URL + 'api/BookingMaster/SpecialBooking',
  API_GET_VEHICLE_LIST_SPECIAL_BOOKING:
    API_SERVER_URL + 'api/BookingMaster/GetVehicleListForSpecialBooking',
  API_POST_APPROVE_BOOKING_REQUEST:
    API_SERVER_URL + 'api/BookingMaster/ApproveBookingRequest',
  API_POST_APPROVE_REJECT_MULTIPLE_BOOKING_REQUEST:
    API_SERVER_URL + 'api/BookingMaster/ApproveRejectMultipleBookingRequest ',
  API_GET_ACTIVE_DRIVER_LIST_BOOKING:
    API_SERVER_URL + 'api/BookingMaster/GetActiveDriverListForBooking',
  API_GET_BOOKING_INFORMATION:
    API_SERVER_URL + 'api/BookingMaster/GetBookingInformation',
  API_CHECK_BOOKING_EXTEND_TIME:
    API_SERVER_URL + 'api/BookingMaster/CheckBookingExtendTime',
  API_EXTEND_ONGOING_BOOKING:
    API_SERVER_URL + 'api/BookingMaster/ExtendOnGoingBooking',
  API_REPORT_DAMAGE: API_SERVER_URL + 'api/ReportDamage/ReportDamage',
  API_RECURRING_BOOKING_DRIVER:
    API_SERVER_URL + 'api/BookingMaster/AllowRecurringBookingForDriver',
  API_ALLOW_TIME_BOOKING_DRIVER:
    API_SERVER_URL + 'api/BookingMaster/AllowTimeForBooking',
  API_POST_UPDATE_BOOKINGTRIP:
    API_SERVER_URL + 'api/BookingTrip/UpdateBookingTrip',
  API_DELETE_BOOKINGTRIP: API_SERVER_URL + 'api/BookingTrip/DeleteBookingTrip',
  API_UPDATE_USER_EXPENSE:
    API_SERVER_URL + 'api/BookingExpense/UpdateUserExpense',
  API_FREE_BOOKING: API_SERVER_URL + 'api/BookingMaster/UpdateFreeBooking',
  API_GET_AQUIRED_TIMESLOT:
    API_SERVER_URL + 'api/BookingMaster/GetAquiredTimeSlots',
  API_GET_NORMAL_BOOKING_LIST:
    API_SERVER_URL + 'api/BookingMaster/GetNormalBookingList',
  API_GET_BOOKING_ORGANIZATION_LIST:
    API_SERVER_URL + 'api/BookingMaster/GetOrganizationListForDriver',
  API_GET_SPECIAL_BOOKING_SVG_LIST:
    API_SERVER_URL + 'api/BookingMaster/GetSharedVehicleGroupListForSpecialBooking',
  API_BOOKINGEXPENSE_VATSETTINGLIST_DROPDOWN:
    API_SERVER_URL + 'api/BookingExpense/GetDropdownVatSetting',
  API_BOOKINGEXPENSE_API_GET_VATSETTING_DEFAULT_VALUES:
    API_SERVER_URL + 'api/BookingExpense/GetVatSettingDefaultValues',
  API_GET_BOOKING_SPECIAL_PERIODS_LIST:
    API_SERVER_URL + 'api/BookingMaster/GetSpecialPeriodList',
  //BookingInvoice
  API_GET_BOOKING_INVOICE_LIST:
    API_SERVER_URL + 'api/BookingInvoice/CCE/GetBookingInvoiceList',
  API_EXPORT_BOOKING_INVOICE_LIST:
    API_SERVER_URL + 'api/BookingInvoice/CCE/ExportBookingInvoice',
  API_RESEND_BOOKING_INVOICE:
    API_SERVER_URL + 'api/BookingInvoice/CCE/ResendBookingInvoice',
  API_DOWNLOAD_BOOKING_INVOICE:
    API_SERVER_URL + 'api/BookingInvoice/CCE/DownloadBookingInvoice',
  API_DOWNLOAD_BOOKING_INVOICE_OFFLINE_PDF:
    API_SERVER_URL + 'api/BookingInvoice/CCE/DownloadOfflineInvoicePDF',
  API_GET_IS_DIRECTDEBIT_ENABLED:
    API_SERVER_URL + 'api/BookingInvoice/IsDirectDebitEnabled',
  API_GET_INVOICE_BASIC_DETAILS:
    API_SERVER_URL + 'api/BookingInvoice/CCE/GetBookingInvoiceBasicDetails',

  //BookingInvoiceLegacy
  API_GET_BOOKING_INVOICE_LIST_LEGACY:
      API_SERVER_URL + 'api/BookingInvoice/GetBookingInvoiceList',
  API_EXPORT_BOOKING_INVOICE_LIST_LEGACY:
      API_SERVER_URL + 'api/BookingInvoice/ExportBookingInvoice',
  API_RESEND_BOOKING_INVOICE_LEGACY:
      API_SERVER_URL + 'api/BookingInvoice/ResendBookingInvoice',
  API_DOWNLOAD_BOOKING_INVOICE_LEGACY:
      API_SERVER_URL + 'api/BookingInvoice/DownloadBookingInvoice',
  API_DOWNLOAD_BOOKING_INVOICE_OFFLINE_PDF_LEGACY:
      API_SERVER_URL + 'api/BookingInvoice/DownloadOfflineInvoicePDF',
  API_GET_IS_DIRECTDEBIT_ENABLED_LEGACY:
      API_SERVER_URL + 'api/BookingInvoice/IsDirectDebitEnabled',
  API_GET_INVOICE_BASIC_DETAILS_LEGACY:
      API_SERVER_URL + 'api/BookingInvoice/GetBookingInvoiceBasicDetails',
  API_GET_UPDATE_DUE_DATE_FOR_INVOICE_LEGACY:
      API_SERVER_URL + 'api/BookingInvoice/UpdateDueDateForInvoice',
  API_POST_UPDATE_INVOICE_STATUS_LEGACY:
      API_SERVER_URL + 'api/BookingInvoice/UpdateInvoiceStatus',
  API_POST_MANUAL_INVOICE_LEGACY:
      API_SERVER_URL + 'api/BookingInvoice/UpdateManualInvoice',

  // Trips
  API_GET_TRIP_OVERVIEW:
    API_SERVER_URL + 'api/DriverMaster/GetTripOverview',
  API_GET_TRIP_DETAILS:
    API_SERVER_URL + 'api/DriverMaster/GetTripDetails',
  API_GET_EDIT_TRIP:
    API_SERVER_URL + 'api/DriverMaster/EditTripDetail',
  API_EXPORT_TRIP_HISTORY_LIST:
    API_SERVER_URL + 'api/DriverMaster/ExportTripHistoryForDriver',
  API_EXPORT_TRIP_LIST: 
    API_SERVER_URL + 'api/DriverMaster/ExportTrips',
  API_EXPORT_TRIP_REQUEST_LIST:
    API_SERVER_URL + 'api/DriverMaster/ExportTripRequest',
  API_GET_TRIP_OVERVIEW_LIST:
    API_SERVER_URL + 'api/DriverMaster/GetTripOverViewList',
  API_GET_TRIP_REQUEST_LIST:
    API_SERVER_URL + 'api/DriverMaster/GetTripRequestList',
  API_GET_TRIP_HISTORY_LIST:
    API_SERVER_URL + 'api/DriverMaster/GetTripHistoryForDriver',
  API_GET_TRIP_INFORMATION:
    API_SERVER_URL + 'api/DriverMaster/GetTripInformation',
  API_POST_TRIP_ANSWER:
    API_SERVER_URL + 'api/DriverMaster/UpdateTripAnswer',


  //Invoice InvoiceTestModel
  API_GET_INVOICE_TEST_LIST:
    API_SERVER_URL + 'api/InvoiceTest/GetInvoiceTestDriver',
  API_POST_GENERATE_INVOICE: API_SERVER_URL + 'api/InvoiceTest/GenerateInvoice',

  //
  API_GET_TEST_TRIP_BOOKING_LIST: API_SERVER_URL + 'api/VTS/GetBookingList',
  API_GET_TEST_TRIP_LIST: API_SERVER_URL + 'api/VTS/GetTripListByBookingId',
  API_CONTACTYPE_LIST:
    API_SERVER_URL + 'api/VTS/GetAllContactTypeGroupInfromation',
  API_POST_TEST_TRIP_DETAIL: API_SERVER_URL + 'api/VTS/BookingTripSimulation',
  API_UPDATE_VTS_VEHICLE_STATUS:
    API_SERVER_URL + 'api/VTS/UpdateVTSVehicleStatus',
  API_UNLOCK_VTS_VEHICLE: API_SERVER_URL + 'api/VTS/UnLockVTSVehicle',
  API_LOCK_VTS_VEHICLE: API_SERVER_URL + 'api/VTS/LockVTSVehicle',
  API_GET_VEHICLE_DAMAGE_REPORT_BY_HASH:
      API_SERVER_URL + 'api/VehicleMaster/GetVehicleDamageHistory',
  API_PETROL_NEED: API_SERVER_URL + 'api/VTS/IsFuelNeed',
  API_CLEANINGNEED: API_SERVER_URL + 'api/VTS/IsCleanigNeed',
  API_UPDATE_VEHICLE_FOR_CLEANING_AND_FUEL:
    API_SERVER_URL + 'api/VTS/UpdateVehicleForCleanningAndFuel',
  API_UPDATE_VEHICLE_FOR_INVALID_TAG_USED:
    API_SERVER_URL + 'api/VTS/UpdateVehicleStatusForInvalidTagUsed',    

  //UserProfile
  API_POST_UserPROFILE_DETAIL:
    API_SERVER_URL + 'api/PersonProfile/UpdateUserProfile',

  //ChangePassword From Profile
  API_POST_CHANGEUSERPASSSWORD:
    API_SERVER_URL + 'api/ChangePassword/ChangePassword',

  //Notification Inbox
  API_GET_NOTIFICATION_INBOX_LIST:
    API_SERVER_URL + 'api/NotificationInbox/GetNotificationInboxList',
  API_GET_SHOW_NOTIFICATION:
    API_SERVER_URL + 'api/NotificationInbox/ShowNotification',
  API_GET_NOTIFICATION_COUNT:
    API_SERVER_URL + 'api/NotificationInbox/GetNotificationCount',
  API_GET_RESET_NOTIFICATION_COUNT:
    API_SERVER_URL + 'api/NotificationInbox/ResetNotificationCount',

  // Template
  API_GET_TEMPLATE_LIST: API_SERVER_URL + 'api/Template/GetTemplateList',
  API_GET_TEMPLATE_BY_HASH: API_SERVER_URL + 'api/Template/GetTemplateByHashId',
  API_GET_SAMPLE_TEMPLATE_BY_HASH:
    API_SERVER_URL + 'api/Template/GetSampleTemplateByHashId',
  API_POST_TEMPLATE_DETAIL: API_SERVER_URL + 'api/Template/UpdateTemplate',
  API_GET_TEMPLATE_NAME_LIST:
    API_SERVER_URL + 'api/Template/GetTemplateNameList',
  API_GET_MASTER_TEMPLATE_BY_HASH:
    API_SERVER_URL + 'api/Template/GetMasterTemplateByHashId',
  API_GET_UNUSED_INSTANCE_LIST_FOR_TEMPLATE:
    API_SERVER_URL + 'api/Template/GetUnusedInsatnceListForTemplate',
  API_POST_DELETE_TEMPLATES: API_SERVER_URL + 'api/Template/DeleteTemplateList',
  API_GENERATE_LATEX_PDF_BY_HASH:
    API_SERVER_URL + 'api/Template/GenerateLatexPdf',
  API_DOWNLAOD_LATEX_PDF_BY_HASH:
    API_SERVER_URL + 'api/Template/DownloadLatexPdf',
  API_GET_TEMPLATE_NAME_RECIPIENT_LIST:
    API_SERVER_URL + 'api/Template/GetTemplateNameRecipientList',

  // Notification Event
  API_GET_NOTIFICATION_EVENT_LIST:
    API_SERVER_URL + 'api/NotificationEvent/GetNotificationEventList',
  API_POST_NOTIFICATION_EVENT_LIST:
    API_SERVER_URL + 'api/NotificationEvent/UpdateNotificationEventList',

  //TimeBlock
  API_POST_TIMEBLOCK_DETAIL: API_SERVER_URL + 'api/TimeBlock/UpdateTimeBlock',
  API_GET_TIMEBLOCK_BY_HASH:
    API_SERVER_URL + 'api/TimeBlock/GetTimeBlockByHashID',

  // Service Offer
  API_GET_SERVICE_OFFER_LIST:
    API_SERVER_URL + 'api/ServiceOffer/GetServiceOfferList',
  API_GET_DISTANCE_UNIT_LIST:
    API_SERVER_URL + 'api/ServiceOffer/GetDistanceUnitList',
  API_GET_TIME_UNIT_LIST: API_SERVER_URL + 'api/ServiceOffer/GetTimeUnitList',

  //SharedVehicle Subscription
  API_GET_SUBSCRIPTION_LIST:
    API_SERVER_URL + 'api/SharedvehicleSubscription/GetSubscriptionBySVGID',
  API_POST_SUBSCRIPTION_DETAIL:
    API_SERVER_URL + 'api/SharedvehicleSubscription/UpdateSubscriptionMaster',
  API_GET_SUBSCRIPTION_BY_HASH:
    API_SERVER_URL + 'api/SharedvehicleSubscription/GetSubscriptionByHashID',
  API_EXPORT_SUBSCRIPTION_LIST:
    API_SERVER_URL + 'api/SharedvehicleSubscription/ExportSubscription',
  API_POST_DELETE_SUBSCRIPTION:
    API_SERVER_URL + 'api/SharedvehicleSubscription/DeleteSubscription',
  API_GET_SUBSCRIPTION_AVAILABILITY:
    API_SERVER_URL +
    'api/SharedvehicleSubscription/GetSubscriptionAvailability',
  API_POST_SUBSCRIPTION_AVAILABILITY:
    API_SERVER_URL +
    'api/SharedvehicleSubscription/UpdateSubscriptionAvailabilityRestriction',
  API_DELETE_SUBSCRIPTION_AVAILABILITY:
    API_SERVER_URL +
    'api/SharedvehicleSubscription/DeleteAvailabilityRestrictionList',
  API_GET_SUBSCRIPTION_AVAILABILITY_BY_HASH:
    API_SERVER_URL +
    'api/SharedvehicleSubscription/GetAvailabilityRestrictionByHashId',
  API_EXPORT_SUBSCRIPTION_AVAILABILITY_LIST:
    API_SERVER_URL +
    'api/SharedvehicleSubscription/ExportAvailabilityRestriction',
  API_GET_SUBSCRIPTION_BASIC_DETAIL:
    API_SERVER_URL + 'api/SharedvehicleSubscription/GetSubscriptionBasicDetail',
  API_GET_DROPDOWN_SUBSCRIPTION_LIST_TEMPLATE:
    API_SERVER_URL +
    'api/SharedvehicleSubscription/GetSubscriptionListForTemplate',

  //Special Period
  API_GET_SPECIALPERIOD_LIST:
    API_SERVER_URL + 'api/SpecialPeriod/GetSpecialPeriodList',
  API_GET_SPECIAL_PERIOD_BY_HASH:
    API_SERVER_URL + 'api/SpecialPeriod/GetSpecialPerionByHashId',
  API_POST_SPECIAL_PERIOD_DETAIL:
    API_SERVER_URL + 'api/SpecialPeriod/UpdateSpecialPeriod',
  API_EXPORT_SPECIAL_PERIOD_LIST:
    API_SERVER_URL + 'api/SpecialPeriod/ExportSpecialPeriod',

  //lock unlock with vts

  API_UnLOCK: API_SERVER_URL + 'api/VTS/UnLockVehicle',
  API_LOCK: API_SERVER_URL + 'api/VTS/LockVehicle',
  API_PARTIALLOCK: API_SERVER_URL + 'api/VTS/PartialLockVehicle',
  API_STARTRIDE: API_SERVER_URL + 'api/VTS/StartTrip',
  API_ENDRIDE: API_SERVER_URL + 'api/VTS/EndTrip',

  // Import Data
  API_VALIDATE_PERSON_CSV:
    API_SERVER_URL + 'api/ImportCSV/ValidatePersonCSVRecord',
  API_IMPORT_PERSON_CSV: API_SERVER_URL + 'api/ImportCSV/ImportPersonRecord',

  //Additional Free items
  API_GET_ADDITIONAL_FREEITEMS:
    API_SERVER_URL + 'api/AdditionalFreeItem/GetAllAdditionalFreeItemList',
  API_GET_DRIVERSUBSCRIPTION_LIST:
    API_SERVER_URL + 'api/AdditionalFreeItem/GetDriverSubscriptionList',
  API_POST_DRIVERSUBSCRIPTION:
    API_SERVER_URL + 'api/AdditionalFreeItem/UpdateAdditionalFreeItems',
  API_EXPORT_DRIVERSUBSCRIPTION:
    API_SERVER_URL + 'api/AdditionalFreeItem/ExportAdditionalFreeItems',
  API_POST_DELETE_DRIVERSUBSCRIPTION:
    API_SERVER_URL + 'api/AdditionalFreeItem/DeleteAdditionalFreeItemList',
  API_GET_ADDITIONALFREEITEM_BY_HASH:
    API_SERVER_URL + 'api/AdditionalFreeItem/GetAdditionalFreeItemByHashID',

  //Trip Detail Report
  API_GET_DRIVER_VEHICLE_LIST:
    API_SERVER_URL + 'api/TripDetailReport/GetDriverVehicleList',
  API_GET_DRIVER_BOOKING_TRIP_LIST:
    API_SERVER_URL + 'api/TripDetailReport/GetTripDetailListForDirver',
  API_EXPORT_TRIP_DETAIL_REPORT:
    API_SERVER_URL + 'api/TripDetailReport/ExportTripDetailReport',
  API_EXPORT_TRIP_DETAIL_REPORT_PDF:
    API_SERVER_URL + 'api/TripDetailReport/ExportTripDetailReportPdf',
  API_GET_TRIP_DATA_LIST: API_SERVER_URL + 'api/TripDetailReport/GetTripData',
  API_EXPORT_TRIP_DATA_REPORT_PDF:
    API_SERVER_URL + 'api/TripDetailReport/ExportTripDataReportPdf',
  API_EXPORT_TRIP_DATA_REPORT_CSV:
    API_SERVER_URL + 'api/TripDetailReport/ExportTripDataXls',
  API_GET_TRIP_COMMENT: 
    API_SERVER_URL + 'api/TripDetailReport/GetTripComment',    
  API_SET_TRIP_COMMENT: 
    API_SERVER_URL + 'api/TripDetailReport/SetTripComment',

  //Kickback Report
  API_GET_KICKBACK_DATA_LIST:
    API_SERVER_URL + 'api/KickbackReport/GetKickbackData',
  API_EXPORT_KICKBACK_REPORT_EXCEL:
    API_SERVER_URL + 'api/KickbackReport/ExportKickBackReportXls',
  API_EXPORT_KICKBACK_REPORT_PDF:
    API_SERVER_URL + 'api/KickbackReport/ExportKickbackReportPdf',

  //Cost Center Report
  API_GET_COST_CENTER_REPORT_DATA:
    API_SERVER_URL + 'api/CostCenterReport/GetCostCenterData',
  API_EXPORT_COST_CENTER_REPORT_EXCEL:
    API_SERVER_URL + 'api/CostCenterReport/ExportCostCenterReportXls',
  API_EXPORT_COST_CENTER_REPORT_PDF:
    API_SERVER_URL + 'api/CostCenterReport/ExportCostCenterReportPdf',

  //Driverlicencedetail
  API_POST_DRIVER_LICENCE_DETAIL:
    API_SERVER_URL + 'api/Backoffice/UpdateDriverLicenceDetail',

  //VTS Troubleshoot
  API_VTS_TROUBLESHOOT_GETVTSSTATUS_URL:
    API_SERVER_URL + 'api/VTSTroubleshoot/GetVtsStatus',
  API_VTS_TROUBLESHOOT_GETOBUSTATUS_URL:
    API_SERVER_URL + 'api/VTSTroubleshoot/GetAllVehicleObuStatus',
  API_VTS_TROUBLESHOOT_EXPORTOBUSTATUS_URL:
    API_SERVER_URL + 'api/VTSTroubleshoot/ExportAllVehicleObuStatus',

  // Event viewer
  API_GET_AUDIT_LOG_TRAIL_LIST:
    API_SERVER_URL + 'api/EventViewer/GetAuditLogTrailList',

  //VTS HISTORY
  API_GET_VTS_HISTORY_LIST: API_SERVER_URL + 'api/VTS/GetVTSHistoryList',
  API_EXPORT_VTS_HISTORY_LIST: API_SERVER_URL + 'api/VTS/ExportVTSHistoryList',

  // OdometerLogTrail
  API_GET_ODOMETERLOGTRAIL_LIST:
    API_SERVER_URL + 'api/OdometerLogTrail/GetOdometerLogList',
  API_GET_ODOMETER_VEHICLE_DROPDOWN_LIST:
    API_SERVER_URL + 'api/OdometerLogTrail/GetVehicleDropdownForOdometer',
  API_GET_ODOMETERLOGTRAIL_BY_HASH:
    API_SERVER_URL + 'api/OdometerLogTrail/GetOdometerByHashID',
  API_POST_ODOMETERLOGTRAIL_DETAIL:
    API_SERVER_URL + 'api/OdometerLogTrail/UpdateOdometerLogTrail',
  API_EXPORT_ODOMETER_LIST:
    API_SERVER_URL + 'api/OdometerLogTrail/ExportOdometerLogTrail',
  API_POST_ODOMETER_DESCRIPTION:
    API_SERVER_URL + 'api/OdometerLogTrail/UpdateDescriptionOfDeviation',

  //Signup form config
  API_POST_SIGNUP_CONFIG_DETAIL:
    API_SERVER_URL + 'api/SignupFormConfig/UpdateSignupFormConfig',
  API_GET_SIGNUP_CONFIG_LIST:
    API_SERVER_URL + 'api/SignupFormConfig/GetAllSignupFormConfig',
  API_GET_SIGNUP_CONFIG_BY_HASH:
    API_SERVER_URL + 'api/SignupFormConfig/GetSignupFormConfigByHashID',
  API_POST_DELETE_SIGNUP_CONFIG:
    API_SERVER_URL + 'api/SignupFormConfig/DeleteSignupFormConfig',
  API_GET_SIGNUP_CONFIG_DETAILS:
    API_SERVER_URL + 'api/Backoffice/GetSignUpConfiguration',
  API_POST_SIGNUP_DETAIL: API_SERVER_URL + 'api/Backoffice/SaveSignupDetail',
  API_GET_SUBSCRIPTION_LIST_SIGNUP:
    API_SERVER_URL + 'api/SignupFormConfig/GetSubscriptiopnListForSignupForm',
  API_EXPORT_SIGNUP_CONFIG:
    API_SERVER_URL + 'api/SignupFormConfig/ExportSignupFormConfig',
  API_GET_SIGNUP_LIST:
    API_SERVER_URL + 'api/SignupForm/GetSignupFormOverviewList',
  API_EXPORT_SIGNUP_LIST:
    API_SERVER_URL + 'api/SignupForm/ExportSignupFormOverviewList',
  API_ACCEPT_REJECT_SIGNUP:
    API_SERVER_URL + 'api/SignupForm/AcceptRejectSignup',

  API_GET_DIRECT_DEBIT_LIST:
    API_SERVER_URL + 'api/BookingInvoice/GetDirectDebitList',
  API_EXPORT_DIRECT_DEBIT_LIST:
    API_SERVER_URL + 'api/BookingInvoice/ExportDirectDebitInvoice',
  API_GET_DIRECTDEBIT: API_SERVER_URL + 'api/BookingInvoice/GetDirectDebitFile',
  API_CREATE_DIRECT_DEBIT_FOR_COMPANY:
    API_SERVER_URL + 'api/BookingInvoice/CreateDirectDebitFileForCompany',
  API_RECREATE_DIRECT_DEBIT_FOR_COMPANY:
    API_SERVER_URL + 'api/BookingInvoice/ReCreateDirectDebitFileForCompany',
  API_GET_DROPDOWN_INSTANCE_LIST_SIGNUPCONFIG:
    API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForSignUpConfig',

  //Sign Out
  API_GET_LOGOUT: API_SERVER_URL + 'api/Logout/Logout',
  API_GET_VEHICLE_OCCUPANCY_REPORT:
    API_SERVER_URL + 'api/VehicleOccupancy/GenerateVehicleOccupancyReport',
  API_EXPORT_VEHICLE_OCCUPANCY_REPORT_PDF:
    API_SERVER_URL + 'api/VehicleOccupancy/ExportVehicleOccupancyReportPDF',
  API_EXPORT_VEHICLE_OCCUPANCY_REPORT_EXCEL:
    API_SERVER_URL + 'api/VehicleOccupancy/ExportVehicleOccupancyReportExcel',

  API_GET_RESOURCE_LABEL: API_SERVER_URL + 'api/BackOffice/GetResourceLable',
  API_GET_CHECK_ACCOUNT_ACTIVATION_TERMS_CONDITION_STATUS:
    API_SERVER_URL +
    'api/Backoffice/CheckAccountActivationTermsConditionStatus',

  //Batch Upload
  API_VALIDATE_BATCH_UPLOAD_PERSON_CSV:
    API_SERVER_URL + 'api/BatchUploadPerson/ValidatePersonCSVRecord',
  API_IMPORT_BATCH_UPLOAD_CSV:
    API_SERVER_URL + 'api/SignupForm/ImportPersonRecord',

  API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST:
    API_SERVER_URL + 'api/MaintenencePlanning/GetMaintenencePlanning',
  API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST_PDF:
    API_SERVER_URL + 'api/MaintenencePlanning/GetMaintenencePlanningPdf',
  API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST_XLS:
    API_SERVER_URL + 'api/MaintenencePlanning/GetMaintenencePlanningXls',

  //Revenue Per Vehicle Report
  API_GET_REVENUE_PER_VEHICLE_LIST:
    API_SERVER_URL + 'api/Revenue/GetRevenuePerVehicle',
  API_EXPORT_REVENUE_PER_VEHICLE_LIST_PDF:
    API_SERVER_URL + 'api/Revenue/GetRevenuePerVehiclePdf',
  API_EXPORT_REVENUE_PER_VEHICLE_LIST_XLS:
    API_SERVER_URL + 'api/Revenue/GetRevenuePerVehicleXls',

  // Snail Trail
  API_POST_SEARCH_SNAIL_TRAIL: API_SERVER_URL + 'api/SnailTrail/GetSnailTrail',
  API_GET_SEARCH_SNAIL_TRAIL_CSV:
    API_SERVER_URL + 'api/SnailTrail/ExportSnailTrail',

  //Customer
  API_POST_CUSTOMER_DETAIL: API_SERVER_URL + 'api/Customer/UpdateCustomer',
  API_GET_CUSTOMER_LIST: API_SERVER_URL + 'api/Customer/GetAllCustomer',
  API_GET_CUSTOMER_BY_HASH: API_SERVER_URL + 'api/Customer/GetCustomerByHashID',
  API_GET_CUSTOMER_BASIC_DETAIL:
    API_SERVER_URL + 'api/Customer/GetCustomerBasicDetail',
  API_POST_DELETE_CUSTOMER: API_SERVER_URL + 'api/Customer/DeleteCustomer',
  API_EXPORT_CUSTOMER_LIST: API_SERVER_URL + 'api/Customer/ExportCustomer',
  API_GET_DROPDOWN_CUSTOMER_LIST:
    API_SERVER_URL + 'api/Customer/GetDropdownCustomerList',
  API_GET_DROPDOWN_CUSTOMER_LIST_TEMPLATE:
    API_SERVER_URL + 'api/Customer/GetDropdownCustomerListForTemplate',
  API_GET_DROPDOWN_CUSTOMER_LIST_FOR_KICK_BACK_REPORT:
    API_SERVER_URL + 'api/Customer/GetDropdownCustomerListForKickBackReport',
  API_GET_DROPDOWN_CUSTOMER_LIST_FOR_COST_CENTER_REPORT:
    API_SERVER_URL + 'api/Customer/GetDropdownCustomerListForCostCenterReport',

  // Role Management
  API_GET_ROLE_LIST: API_SERVER_URL + 'api/Role/GetAllRoleList',
  API_EXPORT_ROLE_LIST: API_SERVER_URL + 'api/Role/ExportRole',
  API_GET_ROLE_BY_HASH: API_SERVER_URL + 'api/Role/GetRoleByHashID',
  API_POST_ROLE_DETAIL: API_SERVER_URL + 'api/Role/UpdateRole',
  API_GET_ENTITY_LIST: API_SERVER_URL + 'api/Role/GetAllDefaultEntityList',
  API_GET_ROLE_LIST_BY_ENTITY: API_SERVER_URL + 'api/Role/GetRoleListByEntity',
  API_GET_ACCESSIBILITY_BY_HASH:
    API_SERVER_URL + 'api/Role/GetAccessibilityMatrixByRoleHashId',
  API_POST_DELETE_ROLE: API_SERVER_URL + 'api/Role/DeleteRole',

  //RoleAvailability
  API_POST_ROLEAVAILABILITY_DETAIL:
    API_SERVER_URL + 'api/RoleAvailability/UpdateRoleAvailability',
  API_GET_ROLEAVAILABILITY_LIST:
    API_SERVER_URL + 'api/RoleAvailability/GetAllRoleAvailability',
  API_GET_ROLEAVAILABILITY_BY_HASH:
    API_SERVER_URL + 'api/RoleAvailability/GetRoleAvailabilityByHashID',
  API_POST_DELETE_ROLEAVAILABILITY:
    API_SERVER_URL + 'api/RoleAvailability/DeleteRoleAvailability',
  API_EXPORT_ROLEAVAILABILITY_LIST:
    API_SERVER_URL + 'api/RoleAvailability/ExportRoleAvailability',
  API_GET_ROLE_FOR_ASSIGN_TO_CUSTOMER_LIST:
    API_SERVER_URL + 'api/RoleAvailability/GetAllRoleForAssignToCustomer',
  API_POST_ADD_ROLEAVAILABILITY:
    API_SERVER_URL + 'api/RoleAvailability/AddRoleAvailability',

  //Admin Of Customer
  API_GET_ADMIN_OF_CUSTOMER_LIST:
    API_SERVER_URL + 'api/AdminOfCustomer/GetAdminOfCustomerList',
  API_POST_DELETE_ADMIN_OF_CUSTOMER:
    API_SERVER_URL + 'api/AdminOfCustomer/DeleteAdminOfCustomerList',
  API_GET_CUSTOMER_ROLEAVAILABILITY_LIST:
    API_SERVER_URL + 'api/AdminOfCustomer/GetAllRoleAvailability',
  API_POST_DELETE_ADMIN_OF_CUSTOMER_ROLE:
    API_SERVER_URL + 'api/AdminOfCustomer/DeleteAdminOfCustomerRole',
  API_POST_ADD_ADMIN_OF_CUSTOMER_ROLE:
    API_SERVER_URL + 'api/AdminOfCustomer/AddAdminOfCustomerRole',
  API_EXPORT_ADMIN_OF_CUSTOMER_LIST:
    API_SERVER_URL + 'api/AdminOfCustomer/ExportAdminOfCustomer',
  API_GET_CUSTOMER_PERSON_TO_INVITE_LIST:
    API_SERVER_URL + 'api/AdminOfCustomer/GetPersonListToInvite',
  API_POST_INVITE_ADMIN_OF_CUSTOMER:
    API_SERVER_URL + 'api/AdminOfCustomer/InviteAdminOfCustomer',

  //Admin Of SharedVehicleGroup
  API_GET_ADMIN_OF_SVG_LIST:
    API_SERVER_URL +
    'api/AdminOfSharedVehicleGroup/GetAdminOfSharedVehicleGroupList',
  API_POST_DELETE_ADMIN_OF_SVG:
    API_SERVER_URL +
    'api/AdminOfSharedVehicleGroup/DeleteAdminOfSharedVehicleGroupList',
  API_GET_SVG_ROLEAVAILABILITY_LIST:
    API_SERVER_URL + 'api/AdminOfSharedVehicleGroup/GetAllRoleAvailability',
  API_POST_DELETE_ADMIN_OF_SVG_ROLE:
    API_SERVER_URL +
    'api/AdminOfSharedVehicleGroup/DeleteAdminOfSharedVehicleGroupRole',
  API_POST_ADD_ADMIN_OF_SVG_ROLE:
    API_SERVER_URL +
    'api/AdminOfSharedVehicleGroup/AddAdminOfSharedVehicleGroupRole',
  API_EXPORT_ADMIN_OF_SVG_LIST:
    API_SERVER_URL +
    'api/AdminOfSharedVehicleGroup/ExportAdminOfSharedVehicleGroup',
  API_GET_SVG_PERSON_TO_INVITE_LIST:
    API_SERVER_URL + 'api/AdminOfSharedVehicleGroup/GetPersonListToInvite',
  API_POST_INVITE_ADMIN_OF_SVG:
    API_SERVER_URL +
    'api/AdminOfSharedVehicleGroup/InviteAdminOfSharedVehicleGroup',

  //Admin Of Instance
  API_GET_ADMIN_OF_INSTANCE_LIST:
    API_SERVER_URL + 'api/AdminOfInstance/GetAdminOfInstanceList',
  API_POST_DELETE_ADMIN_OF_INSTANCE:
    API_SERVER_URL + 'api/AdminOfInstance/DeleteAdminOfInstanceList',
  API_GET_INSTANCE_ROLEAVAILABILITY_LIST:
    API_SERVER_URL + 'api/AdminOfInstance/GetAllRoleAvailability',
  API_POST_DELETE_ADMIN_OF_INSTANCE_ROLE:
    API_SERVER_URL + 'api/AdminOfInstance/DeleteAdminOfInstanceRole',
  API_POST_ADD_ADMIN_OF_INSTANCE_ROLE:
    API_SERVER_URL + 'api/AdminOfInstance/AddAdminOfInstanceRole',
  API_EXPORT_ADMIN_OF_INSTANCE_LIST:
    API_SERVER_URL + 'api/AdminOfInstance/ExportAdminOfInstance',
  API_GET_INSTANCE_PERSON_TO_INVITE_LIST:
    API_SERVER_URL + 'api/AdminOfInstance/GetPersonListToInvite',
  API_POST_INVITE_ADMIN_OF_INSTANCE:
    API_SERVER_URL + 'api/AdminOfInstance/InviteAdminOfInstance',

  //AdminInvitation
  API_GET_CHECK_ADMIN_VALID_ACTIVATION_CODE:
    API_SERVER_URL + 'api/AdminInvitation/CheckActivationCodeIsValid',
  API_GET_CHECK_ADMIN_USER_EXIST_BY_ACTIVATION_CODE:
    API_SERVER_URL + 'api/AdminInvitation/CheckPersonExistByActivationCode',
  API_GET_REJECT_ADMIN_INVITATION_BY_REJECTION_CODE:
    API_SERVER_URL + 'api/AdminInvitation/InvitationRejected',
  API_GET_ACCEPT_ADMIN_INVITATION_BY_APPROVAL_CODE:
    API_SERVER_URL + 'api/AdminInvitation/InvitationAccepted',
  API_POST_ADMIN_ADD_DETAIL:
    API_SERVER_URL + 'api/AdminInvitation/AddPersonProfile',
  API_GET_CHECK_ADMIN_USER_ROLE_EXIST_BY_ACTIVATION_CODE:
    API_SERVER_URL + 'api/AdminInvitation/CheckPersonRoleExistByActivationCode',
  //Admin Of Company
  API_GET_ADMIN_OF_COMPANY_LIST:
    API_SERVER_URL + 'api/AdminOfCompany/GetAdminOfCompanyList',
  API_POST_DELETE_ADMIN_OF_COMPANY:
    API_SERVER_URL + 'api/AdminOfCompany/DeleteAdminOfCompanyList',
  API_GET_COMPANY_ROLEAVAILABILITY_LIST:
    API_SERVER_URL + 'api/AdminOfCompany/GetAllRoleAvailability',
  API_POST_DELETE_ADMIN_OF_COMPANY_ROLE:
    API_SERVER_URL + 'api/AdminOfCompany/DeleteAdminOfCompanyRole',
  API_POST_ADD_ADMIN_OF_COMPANY_ROLE:
    API_SERVER_URL + 'api/AdminOfCompany/AddAdminOfCompanyRole',
  API_EXPORT_ADMIN_OF_COMPANY_LIST:
    API_SERVER_URL + 'api/AdminOfCompany/ExportAdminOfCompany',
  API_GET_COMPANY_PERSON_TO_INVITE_LIST:
    API_SERVER_URL + 'api/AdminOfCompany/GetPersonListToInvite',
  API_POST_INVITE_ADMIN_OF_COMPANY:
    API_SERVER_URL + 'api/AdminOfCompany/InviteAdminOfCompany',

  //Admin Of Instance
  API_GET_ADMIN_OF_ORGANIZATION_LIST:
    API_SERVER_URL + 'api/AdminOfOrganization/GetAdminOfOrganizationList',
  API_POST_DELETE_ADMIN_OF_ORGANIZATION:
    API_SERVER_URL + 'api/AdminOfOrganization/DeleteAdminOfOrganizationList',
  API_GET_ORGANIZATION_ROLEAVAILABILITY_LIST:
    API_SERVER_URL + 'api/AdminOfOrganization/GetAllRoleAvailability',
  API_POST_DELETE_ADMIN_OF_ORGANIZATION_ROLE:
    API_SERVER_URL + 'api/AdminOfOrganization/DeleteAdminOfOrganizationRole',
  API_POST_ADD_ADMIN_OF_ORGANIZATION_ROLE:
    API_SERVER_URL + 'api/AdminOfOrganization/AddAdminOfOrganizationRole',
  API_EXPORT_ADMIN_OF_ORGANIZATION_LIST:
    API_SERVER_URL + 'api/AdminOfOrganization/ExportAdminOfOrganization',
  API_GET_ORGANIZATION_PERSON_TO_INVITE_LIST:
    API_SERVER_URL + 'api/AdminOfOrganization/GetPersonListToInvite',
  API_POST_INVITE_ADMIN_OF_ORGANIZATION:
    API_SERVER_URL + 'api/AdminOfOrganization/InviteAdminOfOrganization',

  // Organization's Subscriptions
  API_GET_SUBSCRIPTION_LIST_FOR_ORGANIZATION:
    API_SERVER_URL +
    'api/OrganizationSubscription/GetSubscriptionByOrganizationHashId',
  API_GET_SUBSCRIPTION_LIST_FOR_ORGANIZATION_TO_INSTANCE:
    API_SERVER_URL +
    'api/OrganizationSubscription/GetSubscriptionListByOrganizationToInstanceId',
  API_POST_ORGANIZATION_SUBSCRIPTION_DETAIL:
    API_SERVER_URL +
    'api/OrganizationSubscription/UpdateOrganizationToSubscriptionMapping',
  API_EXPORT_ORGANIZATION_SUBSCRIPTION_LIST:
    API_SERVER_URL + 'api/OrganizationSubscription/ExportSubscription',
  API_DELETE_ORGANIZATION_SUBSCRIPTION_MAPPING:
    API_SERVER_URL +
    'api/OrganizationSubscription/DeleteSubscriptionToOrganizationMapping',

  // Organization's Drivers
  API_GET_DRIVER_LIST_FOR_ORGANIZATION:
    API_SERVER_URL + 'api/OrganizationDriver/GetDriverListByOrganizationHashId',
  API_GET_DRIVER_LIST_FOR_ORGANIZATION_TO_INSTANCE:
    API_SERVER_URL +
    'api/OrganizationDriver/GetDriverListByOrganizationToInstanceId',
  API_POST_ORGANIZATION_DRIVER_DETAIL:
    API_SERVER_URL + 'api/OrganizationDriver/UpdateOrganizationToDriverMapping',
  API_EXPORT_ORGANIZATION_MAP_DRIVER_LIST:
    API_SERVER_URL + 'api/OrganizationDriver/ExportDriverList',
  API_DELETE_ORGANIZATION_DRIVER_MAPPING:
    API_SERVER_URL + 'api/OrganizationDriver/DeleteDriverToOrganizationMapping',
  API_POST_ORGANIZATION_DRIVER_PERSON_DETAIL:
    API_SERVER_URL + 'api/OrganizationDriver/AddOrganizationDriverPersonMaster',
  API_GET_ORGANIZATION_PERSON_TO_INVITE_AS_DRIVER_LIST:
    API_SERVER_URL + 'api/OrganizationDriver/GetPersonListToInvite',
  API_POST_INVITE_DRIVER_OF_ORGANIZATION:
    API_SERVER_URL + 'api/OrganizationDriver/AddOrganizationDriver',
  API_GET_DRIVER_LIST_FOR_COST_CENTER_REPORT:
    API_SERVER_URL +
    'api/OrganizationDriver/GetOrganizationBasedDriverListForCostCenterReport',

  //Terms and Conditions
  API_GET_TERMSANDCONDITIONS_LIST:
    API_SERVER_URL + 'api/TermsAndConditions/GetTermsAndConditionsList',
  API_EXPORT_TERMSANDCONDITIONS_LIST:
    API_SERVER_URL + 'api/TermsAndConditions/ExportTermsAndConditions',
  API_POST_TERMSANDCONDITIONS_DETAILS:
    API_SERVER_URL + 'api/TermsAndConditions/UpdateTermsAndConditions',
  API_GET_TERMSANDCONDITIONS_BY_HASH:
    API_SERVER_URL + 'api/TermsAndConditions/GetTermsAndConditionsByHashId',
  API_POST_DELETE_TERMSANDCONDITIONS:
    API_SERVER_URL + 'api/TermsAndConditions/DeleteTermsAndConditions',
  API_GET_TERMSANDCONDITION_BYINSTANCEHASH:
    API_SERVER_URL +
    'api/TermsAndConditions/GetTermsAndConditionsByIntanceHashId',
  API_GET_TERMSANDCONDITION_BYACTIVATIONCODE:
    API_SERVER_URL +
    'api/TermsAndConditions/GetTermsAndConditionsByActivationCode',
  API_GET_PRIVACYSTATEMENT_BYACTIVATIONCODE:
    API_SERVER_URL +
    'api/TermsAndConditions/GetPrivacyStatementByActivationCode',
  API_GET_TERMSANDCONDITION_BYPERSONACTIVATIONCODE:
    API_SERVER_URL +
    'api/TermsAndConditions/GetTermsAndConditionsByPersonActivationCode',
  API_GET_PRIVACYSTATEMENT_BYPERSONACTIVATIONCODE:
    API_SERVER_URL +
    'api/TermsAndConditions/GetPrivacyStatementByPersonActivationCode',
  API_GET_TERMSANDCONDITION_BYSIGNUPPARAM:
    API_SERVER_URL +
    'api/TermsAndConditions/GetTermsAndConditionsBySignupParam',
  API_POST_TERMSANDCONDITION_ACTIVITYLOG:
    API_SERVER_URL +
    'api/TermsAndConditions/AddUpdateTermsConditionActivityLog',
  API_GET_ACTION_ON_ACCOUNT_ACTIVATION_TERMS_CONDITION:
    API_SERVER_URL + 'api/Backoffice/ActionOnAccountActivationTermsCondition',
  API_GET_TERMSANDCONDITIONS_ACTIVITY_LIST:
    API_SERVER_URL + 'api/TermsAndConditions/GetTermsAndConditionsActivityList',
  API_GET_TERMSANDCONDITIONS_ACTIVITY_LIST_DRIVER:
    API_SERVER_URL +
    'api/TermsAndConditions/GetTermsAndConditionsActivityListDriver',
  API_EXPORT_TERMSANDCONDITIONS_ACTIVITY_LIST:
    API_SERVER_URL + 'api/TermsAndConditions/ExportTermsAndConditionsActivity',
  API_EXPORT_TERMSANDCONDITIONS_ACTIVITY_LIST_DRIVER:
    API_SERVER_URL +
    'api/TermsAndConditions/ExportTermsAndConditionsActivityListDriver',
  API_GET_TERMSANDCONDITIONS_ACTIVITY_BY_HASH:
    API_SERVER_URL +
    'api/TermsAndConditions/GetTermsAndConditionsActivityLogByHashId',
  API_POST_REVOKE_TERMSANDCONDITIONS:
    API_SERVER_URL + 'api/TermsAndConditions/RevokeTermsAndConditions',
  API_GET_TERMSANDCONDITION_FOR_DRIVER:
    API_SERVER_URL + 'api/TermsAndConditions/GetTermsConditionForDriver',
  // Privacy Statements
  API_GET_PRIVACYSTATEMENTS_BYSIGNUPPARAM:
    API_SERVER_URL + 'api/TermsAndConditions/GetPrivacyBySignupParam',
  API_GET_CHECK_ACCOUNT_ACTIVATION_PRIVACYSTATEMENT_STATUS:
    API_SERVER_URL + 'api/Backoffice/CheckAccountActivationPrivacyStatus',
  //Cost And Expenses

  API_GET_COSTANDEXPENSE_LIST:
    API_SERVER_URL + 'api/CostAndExpense/GetCostAndExpenseList',
  API_EXPORT_COSTANDEXPENSE_LIST:
    API_SERVER_URL + 'api/CostAndExpense/ExportCostAndExpenseList',
  API_POST_DELETE_COSTANDEXPENSE:
    API_SERVER_URL + 'api/CostAndExpense/DeleteCostAndExpenseList',
  API_GET_COSTANDEXPENSE_BY_HASH:
    API_SERVER_URL + 'api/CostAndExpense/GetCostAndExpenseByHashID',
  API_GET_DROPDOWN_COSTTYPE_LIST:
    API_SERVER_URL + 'api/CostAndExpense/GetDropdownCostTypeList',
  API_GET_DROPDOWN_COSTANDEXPENSE_ORGANIZATION_LIST:
    API_SERVER_URL + 'api/CostAndExpense/GetDropdownOrganizationList',
  API_POST_APPROVE_REJECT_COSTANDEXPENSE:
    API_SERVER_URL + 'api/CostAndExpense/ApproveRejectCostAndExpense',
  API_POST_UPDATE_COSTANDEXPENSE:
    API_SERVER_URL + 'api/CostAndExpense/UpdateCostAndExpense',
  API_GET_APPROVED_COSTANDEXPENSE_LIST:
    API_SERVER_URL + 'api/CostAndExpense/GetApprovedExpenseList',
  API_POST_REMOVE_COSTANDEXPENSE_FROM_INVOICE:
    API_SERVER_URL + 'api/CostAndExpense/RemoveCostAndExpenseFromInvoice',
  API_GET_COST_TYPE_LIST_FOR_COST_CENTER_REPORT:
    API_SERVER_URL + 'api/CostAndExpense/GetCostTypeListForCostCenterReport',
  API_POST_UPDATE_COSTANDEXPENSE_MANUALINVOICE:
    API_SERVER_URL + 'api/CostAndExpense/UpdateCostAndExpenseManualInvoice',

  //Invoice List
  API_DELETE_INVOICE: API_SERVER_URL + 'api/BookingInvoice/DeleteInvoice',
  API_INVOICE_PAYMENT_HISTORY_LIST:
    API_SERVER_URL + 'api/Payment/GetPaymentHistoryByInvoiceId',
  API_EXPORT_INVOICE_PAYMENT_HISTORY:
    API_SERVER_URL + 'api/Payment/ExportPaymentHistoryByInvoiceId',

  //Invoice Update
  API_GET_DRIVER_LIST_INVOICE:
    API_SERVER_URL + 'api/BookingInvoice/GetDriverListForInvoice',
  API_GET_ORGANIZATION_LIST_INVOICE:
    API_SERVER_URL + 'api/BookingInvoice/GetOrganizationListForInvoice',
  API_POST_MANUAL_INVOICE:
    API_SERVER_URL + 'api/BookingInvoice/CCE/UpdateManualInvoice',
  API_GET_INVOICE_NUMBER:
    API_SERVER_URL + 'api/BookingInvoice/GetInvoiceNumber',
  API_GET_INVOICE_BY_HASH:
    API_SERVER_URL + 'api/BookingInvoice/GetManualInvoiceByHashID',
  API_GET_COMPANY_ADDRESS:
    API_SERVER_URL + 'api/BookingInvoice/GetCompanyAddress',
  API_GET_DRIVER_ADDRESS:
    API_SERVER_URL + 'api/BookingInvoice/GetDriverAddress',
  API_GET_ORGANIZATION_ADDRESS:
    API_SERVER_URL + 'api/BookingInvoice/GetOrganizationAddress',
  API_GET_DROPDOWN_MANUAL_INVOICE_BOOKING_LIST:
    API_SERVER_URL + 'api/BookingInvoice/GetBookingDropDownList',
  API_GET_UPDATE_DUE_DATE_FOR_INVOICE:
    API_SERVER_URL + 'api/BookingInvoice/CCE/UpdateDueDateForInvoice',
  API_POST_UPDATE_INVOICE_STATUS:
    API_SERVER_URL + 'api/BookingInvoice/CCE/UpdateInvoiceStatus',
  API_GET_INVOICE_REOPEN_REASON_DROPDOWN_URL:
    API_SERVER_URL + 'api/BookingInvoice/GetReopenReasonDropdownList',
  API_GET_INVOICE_CLOSED_REASON_DROPDOWN_URL:
    API_SERVER_URL + 'api/BookingInvoice/GetClosedReasonDropdownList',

  //Pre post trip question
  API_PRE_POST_TRIP_QUESTION_LIST:
    API_SERVER_URL + 'api/PrePostTripQuestion/GetPrePostQuestionList',
  API_PRE_POST_TRIP_QUESTION_DETAILS:
    API_SERVER_URL + 'api/PrePostTripQuestion/GetAllPrePostTripQuestionList',
  API_PRE_POST_TRIP_QUESTION_CUSTOM:
    API_SERVER_URL + 'api/PrePostTripQuestion/ValidatePrePostCustomQuestion',
  API_PRE_POST_TRIP_QUESTION_UPDATE:
    API_SERVER_URL + 'api/PrePostTripQuestion/UpdatePrePostTripQuestionMaster',
  API_PRE_POST_TRIP_QUESTION_BY_HASHID:
    API_SERVER_URL + 'api/PrePostTripQuestion/GetPrePostTripQuestionByHashID',
  API_PRE_POST_TRIP_QUESTION_BY_INSTANCEHASHID:
    API_SERVER_URL +
    'api/PrePostTripQuestion/GetPrePostTripQuestionByInstanceHashID',

  //Pre post trip question overview
  API_PRE_POST_QUESTION_OVERVIEW:
    API_SERVER_URL + 'api/PrePostTripQuestion/GetPrePostQuestionOverviewList',
  API_GET_PRE_POST_QUESTION_NAME:
    API_SERVER_URL + 'api/PrePostTripQuestion/GetDropdownQuestionTypeList',
  API_PRE_POST_QUESTION__Export:
    API_SERVER_URL + 'api/PrePostTripQuestion/ExportPrePostQuestionsOverview',
  API_GET_IS_AUTHORIZE_FOR_PREPOST_QUESTION:
    API_SERVER_URL + 'api/PrePostTripQuestion/IsAuthorizeForPrePostQuestions',

  //Credit card payment
  API_GET_VERIFY_REDIRECT_FOR_PAYMENT:
    API_SERVER_URL + 'api/BookingMaster/VerifyRedirectKeyForPayment',
  API_DELETE_CREDITCARD_DETAILS_BYHASHID:
    API_SERVER_URL + 'api/PersonMaster/DeleteCreditCardDetailsByHashId',
  API_UPDATE_BOOKING_SUCCESSPAYMENT:
    API_SERVER_URL + 'api/BookingMaster/UpdateBookingAfterSuccessfulPayment',


  //Invoice InvoiceMissingSendModel
  API_GET_INVOICE_MISSING_SEND_LIST:
    API_SERVER_URL + 'api/InvoiceMissingSend/GetInvoiceMissingDriver',
  API_POST_GENERATE_MISSING_INVOICE: API_SERVER_URL + 'api/InvoiceMissingSend/GenerateInvoice',
  //

  //TwoFA
  API_GET_TWOFA_GOOGLE_SETUP_DETAILS:
    API_SERVER_URL + 'api/TwoFAAuth/GetTwoFAGoogleSetupCode',
  API_VERIFY_TWOFA_TOTP:
    API_SERVER_URL + 'api/TwoFAAuth/VerifyTwoFAGoogleTOTP',
  API_SEND_TWOFA_EMAIL_CODE:
    API_SERVER_URL + 'api/TwoFAAuth/SendTwoFaEmailCode',
  API_VERIFY_EMAIL_CODE:
    API_SERVER_URL + 'api/TwoFAAuth/VerifyTwoFAEmailOTP',
  //

  //SSO
  API_GET_SSO_CONFIG:
    SSO_BASE_URL + 'saml/GetSingleSignOnConfig',
  API_GET_INITIATE_SSO:
    SSO_BASE_URL + 'saml/InitiateSingleSignOn/',
  API_GET_ASSERTION_SSO:
    SSO_BASE_URL + 'saml/TokenAssertionConsumerService/',   
  //

  //Fix RFID Tag
  API_CORRECT_TAG:
    API_SERVER_URL + 'api/PersonMaster/CorrectTag',
  //  
};

export const UserRoles = {
  WEGOADMIN: 'WEGOADMIN',
  COMPANYADMIN: 'COMPANYADMIN',
  GROUPADMIN: 'GROUPADMIN',
  ORGANIZATIONADMIN: 'ORGANIZATIONADMIN',
  DRIVER: 'DRIVER',
  PERSON: 'PERSON',
  ADMIN: 'ADMIN'
};
export const BookingStatus = {
  PROVISIONAL: 'PROVISIONAL',
  CONFIRMED: 'CONFIRMED',
  CANCELLED: 'CANCELLED',
  ABORTED: 'ABORTED',
  REVOKED: 'REVOKED',
  FINISHED: 'FINISHED',
  PENDING: 'PENDING'
};
export const BookingType = {
  NORMAL: 'NORMAL',
  MAINTENANCE: 'MAINTENANCE',
  UNAVAILABLE: 'UNAVAILABLE'
};

export const QuestionType = {
  PREBEFORE: 'PREBEFORE',
  PREAFTER: 'PREAFTER',
  POST: 'POST'
};
export const ApplicationRouteURL = {
  URL_DEFAULT_PAGE: '',
  URL_DASHBOARD_PAGE: 'dashboard',
  URL_BRANDING_PAGE: 'branding',
  URL_INBOX_PAGE: 'inbox',
  URL_TERMS_CONDITION_PAGE: 'termsandcondition',
  URL_INSTANCE_LIST: 'instance/list',
  URL_INSTANCE_UPDATE: 'instance/update',
  URL_INSTANCE_ADD: 'instance/add',

  URL_PERSON_LIST: 'person/list',
  URL_PERSON_ADD: 'person/add',
  URL_PERSON_UPDATE: 'person/update',
  URL_COMPANY_LIST: 'company/list',
  URL_ERRORLOG_List: 'errorlog/list',
  URL_ERROR_ESCALATION_LIST: 'errorescalation/list',
  URL_ERROR_ESCALATION_UPDATE: 'errorescalation/update',
  URL_ERROR_ESCALATION_ADD: 'errorescalation/add',
  URL_INTERFACESTATUS_List: 'interfacestatus/list',
  URL_COMPANY_UPDATE: 'company/update',
  URL_COMPANY_ADD: 'company/add',
  URL_COMPANYADMIN_LIST: 'companyAdmin/list',
  URL_SVG_LIST: 'sharedvehiclegroup/list',
  URL_SVG_ADD: 'sharedvehiclegroup/add',
  URL_SVG_UPDATE: 'sharedvehiclegroup/update',
  URL_SVGADMIN_LIST: 'sharedvehiclegroupadmin/list',
  URL_VEHICLE_LIST: 'vehicle/list',
  URL_SVGVEHICLE_LIST: 'sharedvehiclegroup/svgvehicle',
  URL_SVGDRIVER_LIST: 'sharedvehiclegroup/svgdriver',
  URL_VEHICLE_ADD: 'vehicle/add',
  URL_VEHICLE_UPDATE: 'vehicle/update',
  URL_VTSVEHICLE_ADD: 'vtsvehicle/add',
  URL_VTSVEHICLE_UPDATE: 'vtsvehicle/update',
  URL_VTSVEHICLE_LIST: 'vtsvehicle/list',
  //URL_VEHICLE_SVG_LIST: 'vehicle/svglist',
  URL_VEHICLE_INFO: 'vehicle/vehicleinformation',
  URL_REPORT_DAMGE_UPDATE: 'vehicle/updatereportdamage',

  URL_DRIVER_LIST: 'driver/list',
  URL_DRIVER_UPDATE: 'driver/update',
  URL_VEHICLEATTRIBUTE_LIST: 'vehicleattribute/list',
  URL_VEHICLEATTRIBUTE_ADD: 'vehicleattribute/add',
  URL_VEHICLEATTRIBUTE_UPDATE: 'vehicleattribute/update',

  URL_DRIVER_SVG_LIST: 'driverSVG/list',
  URL_CONTRACT_TYPE_LIST: 'contractType/list',
  URL_CONTRACT_TYPE_ADD: 'contractType/add',
  URL_CONTRACT_TYPE_UPDATE: 'contractType/update',

  URL_CONTRACT_TYPE_GROUP_LIST: 'contractTypegroup/list',
  URL_CONTRACT_TYPE__GROUP_ADD: 'contractTypegroup/add',
  URL_CONTRACT_TYPE__GROUP_UPDATE: 'contractTypegroup/update',

  URL_VEHICLEATTRIBUTE_CATEGORY_LIST: 'vehicleattributecategory/list',
  URL_VEHICLEATTRIBUTE_CATEGORY_UPDATE: 'vehicleattributecategory/update',
  URL_VEHICLEATTRIBUTE_CATEGORY_ADD: 'vehicleattributecategory/add',
  URL_BOOKING: 'booking',
  URL_BOOKING_OVERVIEW: 'booking/overview',
  URL_BOOKING_REQUEST: 'booking/request',
  URL_COST_EXPENSE_DRIVER_LIST: 'drivercostexpense/list',
  URL_SNAIL_TRAIL_DRIVER: 'snailtrail',
  URL_BOOKING_HISTORY: 'booking/history',
  URL_BOOKING_INFORMATION: 'booking/information',
  URL_BOOKING_INFORMATION2: 'booking/information2',
  URL_BOOKING_INFORMATION3: 'booking/information3',
  URL_BOOKING_INFORMATION_DRIVER: 'bookinginformation',
  URL_DRIVER_PROFILE: 'profile',
  URL_USER_PROFILE_UPDATE: 'userprofile',
  URL_TEMPLATE_LIST: 'template/list',
  URL_TEMPLATE_UPDATE: 'template/update',
  URL_TEMPLATE_ADD: 'template/add',
  URL_TRIP_HISTORY: 'trip/history',
  URL_TRIP_INFORMATION_DRIVER: 'tripinformation',
  URL_TRIP_INFORMATION: 'trip/information',
  

  URL_SERVICE_OFFER_LIST: 'serviceoffer/list',
  URL_TIMEBLOCK_UPDATE: 'timeblock/update',
  URL_TERMS_CONDITION_ACTIVITY_DRIVER: 'TAndCLog',
  URL_SUBSCRIPTION_LIST: 'subscription/list',
  URL_SUBSCRIPTION_UPDATE: 'subscription/update',
  URL_SUBSCRIPTION_ADD: 'subscription/update',

  URL_SPECIAL_PERIOD_LIST: 'specialperiod/list',
  URL_SPECIAL_PERIOD_UPDATE: 'specialperiod/update',

  URL_WEGOADMIN_LIST: 'wegoadminlist/list',
  URL_BOOKING_INVOICE_LIST: 'invoice/list',
  URL_BOOKING_INVOICE_LEGACY_LIST: 'invoice-legacy/list',
  URL_BOOKING_INVOICE_TEST_LIST: 'invoicetest/list',
  URL_BOOKING_INVOICE_MISSING_SEND_LIST: 'invoicemissingsend/list',
  URL_SPECIAL_BOOKING: 'specialbooking',
  URL_BOOKING_TRIP_TEST: 'bookingtriptest',
  URL_UNLOCK: '/mobile/unlock',
  URL_START_RIDE: '/mobile/startride',
  URL_DIRECTDEBIT_LIST: 'directdebit/list',

  URL_IMPORT_PERSON: 'import/person',
  URL_DRIVER_LICENCE: 'validatedriverlicence/driverlicencedetail',

  URL_SUBSCRIPTIONAVAILABILITY_LIST: 'subscriptionavailabilityrestriction-list',
  URL_SUBSCRIPTIONAVAILABILITY_UPDATE:
    'subscriptionavailabilityrestriction-update',
  URL_SUBSCRIPTIONAVAILABILITY_ADD: 'subscriptionavailabilityrestriction-add',

  URL_ADDITIONALFREEITEM_UPDATE: 'additionalfreeitem/update',
  URL_ADDITIONALFREEITEM_ADD: 'additionalfreeitem/add',
  URL_ADDITIONALFREEITEM_LIST: 'additionalfreeitem/list',
  URL_TRIP_DETAIL_REPORT: 'tripdetailreport',
  URL_VEHICLE_FUTURE_BOOKING_LIST: 'vehiclefuterbooking',

  URL_VTS_TROUBLESHOOT: 'vtstroubleshoot',

  URL_EVENT_VIEWER_LIST: 'eventviewer',
  URL_VTS_HISTORY_LIST: 'vtseventhistory',

  URL_ORGANIZATION_ADD: 'organization/add',
  URL_ORGANIZATION_UPDATE: 'organization/update',
  URL_ORGANIZATION_LIST: 'organization/list',
  URL_ORGANIZATION_ADMIN_LIST: 'organizationAdmin/list',
  URL_ORGANIZATION_DRIVER_LIST: 'organizationDriver/list',

  URL_DRIVERINVOICE_LIST: 'driverinvoice/list',
  URL_VEHICLE_OCCUPANCY_REPORT: 'report/vehicleoccupancy',
  URL_ODOMETERLOGTRAIL_LIST: 'odometerlogtrail/list',
  URL_ODOMETERLOGTRAIL_ADD: 'odometerlogtrail/add',
  URL_ODOMETERLOGTRAIL_UPDATE: 'odometerlogtrail/update',

  URL_SIGNUPFORM_LIST: 'signupform/list',
  URL_SIGNUPFORM_UPDATE: 'signupform/update',
  URL_SIGNUPFORM_ADD: 'signupform/add',

  URL_SIGNUP_LIST: 'signup/list',
  URL_BATCHUPLOADPERSON: 'batchupload/person',

  URL_REVENUE_PER_VEHICLE_REPORT: 'report/revenuepervehiclereport',
  URL_MAINTENANCE_PLANNING_REPORT: 'report/maintenanceplanningreport',
  URL_TRIPDATA_REPORT: 'tripdatareport/tripdatareport',

  URL_SNAIL_TRAIL_REPORT: 'report/snailtrail',
  URL_KICKBACK_REPORT: 'report/kickback',
  URL_ROLE_LIST: 'role/list',
  URL_ROLE_UPDATE: 'role/update',

  URL_CUSTOMER_LIST: 'customer/list',
  URL_CUSTOMER_ADD: 'customer/add',
  URL_CUSTOMER_UPDATE: 'customer/update',

  URL_ROLEAVAILABILITY_LIST: 'roleavailability/list',

  URL_ADMIN_OF_CUSTOMER_LIST: 'adminsofcustomer/list',
  URL_ADMIN_OF_SHAREDVEHICLEGROUP_LIST: 'adminsofsharedvehiclegroup/list',
  URL_ADMIN_OF_INSTANCE_LIST: 'adminsofinstance/list',
  URL_ADMIN_OF_COMPANY_LIST: 'adminsofcompany/list',
  URL_ADMIN_OF_ORGANIZATION_LIST: 'adminsoforganization/list',

  URL_ORGANIZATION_TO_SUBSCRIPTION_LIST: 'organizationtosubscription/list',
  URL_ORGANIZATION_TO_DRIVER_LIST: 'organizationtodriver/list',

  URL_TERMS_AND_CONDITION_ADD: 'termsandcondition/add',
  URL_TERMS_AND_CONDITION_UPDATE: 'termsandcondition/update',
  URL_TERMS_AND_CONDITION_POPUP: 'termsconditionpopup/popup',

  URL_COSTANDEXPENSE_LIST: 'costandexpense/list',
  URL_INVOICE_UPDATE: 'invoice/update',
  URL_COST_CENTER_REPORT: 'report/costcenterreport',

  URL_PAYMENT_HISTORY: 'invoice/invoicePaymentHistory',
  //Pre - post - trip question
  URL_PRE_POST_QUESTION: 'preposttripquestion',
  URL_PRE_POST_QUESTION_UPDATE: 'preposttripquestion/update',
  URL_PRE_POST_QUESTION_ADD: 'preposttripquestion/add',

  //pre-post-trip-questions overview
  URL_PRE_POST_TRIP_QUESTION_OVERVIEW: 'prepostquestionsoverview',
  URL_PRIVACY_STATEMENT_POPUP: 'privacystatement/popup',

  URL_TWO_FA_SELECTION: 'twofaselection',
  URL_TWO_FA_GOOGLE_SETUP: 'twofagooglesetup',
  URL_TWO_FA_EMAIL_OTP: 'twofaemailotp'

};

export const PermissionType = {
  VIEW: 'VIEW',
  INSERT: 'INSERT',
  EDIT: 'EDIT',
  DELETE: 'DELETE'
};

export const Entity = {
  CUSTOMER: 'Customer',
  INSTANCE: 'Instance',
  COMPANY: 'Company',
  SVG: 'SVG',
  ORGANIZATION: 'Organization',
  DRIVER: 'Driver'
};

export const Permission = {
  PR_CUSTOMER_OVERVIEW: 'PR_CUSTOMER_OVERVIEW',
  PR_DASHBOARD: 'PR_DASHBOARD',
  PR_INSTANCE: 'PR_INSTANCE',
  PR_BRANDING: 'PR_BRANDING',
  PR_PERSON_OVERVIEW: 'PR_PERSON_OVERVIEW',
  PR_WEGO_ADMINS: 'PR_WEGO_ADMINS',
  PR_COMPANY_OVERVIEW: 'PR_COMPANY_OVERVIEW',
  PR_ERRORLOG: 'PR_ERRORLOG',
  PR_INTERFACE_STATUS: 'PR_INTERFACE_STATUS',
  PR_CONTACT_PERSON: 'PR_CONTACT_PERSON',
  PR_COMPANY_ADMIN: 'PR_COMPANY_ADMIN',
  // PR_COMPANY_VEHICLE_OVERVIEW: "PR_COMPANY_VEHICLE_OVERVIEW",
  // PR_COMPANY_SVG_OVERVIEW: "PR_COMPANY_SVG_OVERVIEW",
  PR_ORGANIZATION_OVERVIEW: 'PR_ORGANIZATION_OVERVIEW',
  PR_ORGANIZATION_CONTACT_PERSON: 'PR_ORGANIZATION_CONTACT_PERSON',
  PR_ORGANIZATION_ADMIN_OVERVIEW: 'PR_ORGANIZATION_ADMIN_OVERVIEW',
  PR_ORGANIZATION_DRIVER_OVERVIEW: 'PR_ORGANIZATION_DRIVER_OVERVIEW',
  PR_SHARED_VEHICLE_GROUP_OVERVIEW: 'PR_SHARED_VEHICLE_GROUP_OVERVIEW',
  PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW:
    'PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW',
  PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW:
    'PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW',
  PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW:
    'PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW',
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW:
    'PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW',
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW:
    'PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW',
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    'PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW',
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW:
    'PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW',
  PR_SPECIAL_PERIODS: 'PR_SPECIAL_PERIODS',
  PR_VEHICLES_OVERVIEW: 'PR_VEHICLES_OVERVIEW',
  PR_VEHICLE_SVG_OVERVIEW: 'PR_VEHICLE_SVG_OVERVIEW',
  PR_VTS_VEHICLE_LIST: 'PR_VTS_VEHICLE_LIST',
  PR_VTS_TROUBLESHOOT: 'PR_VTS_TROUBLESHOOT',
  PR_VEHICLE_ATTRIBUTE_CATEGORIES: 'PR_VEHICLE_ATTRIBUTE_CATEGORIES',
  PR_VEHICLE_ATTRIBUTE: 'PR_VEHICLE_ATTRIBUTE',
  PR_VEHICLE_FUTURE_BOOKINGS: 'PR_VEHICLE_FUTURE_BOOKINGS',
  PR_ODOMETER_LOG_TRAIL: 'PR_ODOMETER_LOG_TRAIL',
  PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: 'PR_ODOMETER_LOG_TRAIL_REGISTERED_BY',
  PR_DRIVER_OVERVIEW: 'PR_DRIVER_OVERVIEW',
  PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW:
    'PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW',
  PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    'PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW',
  PR_BOOKINGS_OVERVIEW: 'PR_BOOKINGS_OVERVIEW',
  PR_BOOKINGS_REQUEST: 'PR_BOOKING_REQUEST',
  PR_NORMAL_BOOKING: 'PR_NORMAL_BOOKING',
  PR_SPECIAL_BOOKING: 'PR_SPECIAL_BOOKING',
  PR_TRIP_SIMULATOR: 'PR_TRIP_SIMULATOR',
  PR_INVOICE: 'PR_INVOICE',
  PR_INVOICE_PAYMENT_HISTORY: 'PR_INVOICE_PAYMENT_HISTORY',
  PR_INVOICE_PAYMENT_HISTORY_LIST: 'PR_PAYMENT_HISTORY_LIST',
  PR_DIRECT_DEBIT_FILE: 'PR_DIRECT_DEBIT_FILE',
  PR_ADDITIONAL_FREE_ITEMS: 'PR_ADDITIONAL_FREE_ITEMS',
  PR_TEST_INVOICE_GENERATOR: 'PR_TEST_INVOICE_GENERATOR',
  PR_MISSING_INVOICE_GENERATOR: 'PR_MISSING_INVOICE_GENERATOR',
  PR_VEHICLE_OCCUPANCY_REPORT: 'PR_VEHICLE_OCCUPANCY_REPORT',
  PR_REVENUE_PER_VEHICLE_REPORT: 'PR_REVENUE_PER_VEHICLE_REPORT',
  PR_TRIP_DATA_REPORT: 'PR_TRIP_DATA_REPORT',
  PR_MAINTENANCE_PLANNING_REPORT: 'PR_MAINTENANCE_PLANNING_REPORT',
  PR_SANIL_TRAIL_REPORT: 'PR_SANIL_TRAIL_REPORT',
  PR_KICKBACK_REPORT: 'PR_KICKBACK_REPORT',
  PR_TEMPLATES: 'PR_TEMPLATES',
  PR_SIGNUP_FORMS_OVERVIEW: 'PR_SIGNUP_FORMS_OVERVIEW',
  PR_SIGNUPS_OVERVIEW: 'PR_SIGNUPS_OVERVIEW',
  PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: 'PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM',
  PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP:
    'PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP',
  PR_EVENT_VIEWER: 'PR_EVENT_VIEWER',
  PR_USER_PROFILE: 'PR_USER_PROFILE',
  PR_CUSTOMER_ADMIN_OVERVIEW: 'PR_CUSTOMER_ADMIN_OVERVIEW',
  PR_INSTANCE_ADMIN_OVERVIEW: 'PR_INSTANCE_ADMIN_OVERVIEW',
  PR_ROLE_OVERVIEW: 'PR_ROLE_OVERVIEW',
  PR_ROLE_ASSIGN: 'PR_ROLE_ASSIGN',
  PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE:
    'PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE',
  PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW:
    'PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW',
  PR_BATCH_UPLOAD_PERSON: 'PR_BATCH_UPLOAD_PERSON',
  PR_ERRORESCALATION_OVERVIEW: 'PR_ERROR_ESCALATION_OVERVIEW',
  PR_IMPORT_PERSON: 'PR_IMPORT_PERSON',
  PR_TERMS_AND_CONDITION: 'PR_TERMS_AND_CONDITION',
  PR_COSTANDEXPENSES_LIST: 'PR_COST_EXPENSES',
  PR_COST_CENTER_REPORT: 'PR_COST_CENTER_REPORT',
  PR_PRE_POST_TRIP_SETTING: 'PR_PRE_POST_TRIP_SETTING',
  PR_PRE_POST_TRIP_QUESTIONS: 'PR_PRE_POST_TRIP_QUESTIONS',
  PR_PREPOST_TRIP_QUESTIONS_UPDATE: 'PR_PREPOST_TRIP_QUESTIONS_UPDATE'
};

export class WeGoAuthorizedLink {
  constructor(
    routerLink: any,
    permissionName: string,
    permissionType: string,
    cssClass: string,
    label: string,
    Entity: string = '',
    EntityId: string = '',
    displayElementIfNotAuth: boolean = false,
    iconClass: string = ''
  ) {
    this.routerLink = routerLink;
    this.permissionName = permissionName;
    this.permissionType = permissionType;
    this.cssClass = cssClass;
    this.label = label;
    this.EntityId = EntityId;
    this.Entity = Entity;
    this.displayElementIfNotAuth = displayElementIfNotAuth;
    this.iconClass = iconClass;
  }
  routerLink: any;
  cssClass: string;
  label: string;
  permissionName: string;
  permissionType: string;
  EntityId: string;
  Entity: string;
  iconClass: string;
  displayElementIfNotAuth: boolean;
}

export interface Marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
  isOpen: boolean;
}

export interface IStatus {
  dateTimeUTC: string;
  version: string;
  isSpecialBookingExist: boolean;
}

export interface IAPIResponse {
  data: any;
  error: any;
  totalRecords: number;
  status: IStatus;
}

export interface IKeyValueInterface {
  key: string;
  value: string;
}

export interface IDropDownInterface {
  keyHash: string;
  value: string;
}

export enum RoleLevel {
  WeGo = 0,
  Customer = 1,
  Instance = 2,
  Company = 3,
  SVG = 4,
  Organization = 5
}

export enum PreferredLanguage {
  NL = 1,
  EN = 2,
  DE = 3
}

export class DataListModel {
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = WeGoConfig.GRID_MAX_PAGE_SIZE;
  public itemsPerPage: number;
  public sortType: string = '';
  public sortReverse: boolean = false;
  public searchField: string[] = [];
  public searchTerm: string = '';
  public infoMessage: string = '';
  constructor() {
    // let selectedNumber = localStorage.getItem("itemsPerPage");
    // if (selectedNumber) {
    //   this.itemsPerPage = parseInt(selectedNumber);
    // }
    // else {
    this.itemsPerPage = WeGoConfig.GRID_MAX_DATA_SIZE;
    // }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/config.ts